<template>
  <div class="row">
    <div class="col-12 row">
      <div class="col-lg-3 col-sm-4">
        <ul id="table_show" class="card-title2">
          <base-dropdown title-classes="btn btn-secondary"
                         title="Documentos">
            <button @click="myDocs ? myDocs = !myDocs : '';onRefresh;" type="button" class="btn-file btn mb-0 btn-light text-secondary">
              <i class="fas fa-list mr-1"></i>
              {{$t("archivos_carpetas")}}
            </button>
            <button @click="getMyDocs" type="button" class="btn-file btn mb-0 btn-light text-secondary">
              <i class="fas fa-th-large mr-1"></i>
              {{$t("mis_documentos")}}
            </button>
          </base-dropdown>
        </ul>
      </div>
      <div style="display: none" class="col-lg-6 mb-3">
        <div class="row">
          <div class="col-12 font14">
            {{$t("FiltrosBusq")}}
            <hr class="mt-1">
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4">
            <label for="">
              {{$t("name")}}
            </label>
          </div>
          <div class="col-lg-8">
            <form v-on:submit.prevent="onSearchFilter">
              <div class="mr-3 d-flex" >
                <input type="text" v-model="filter"  class="form-control  rounded-left rounded-0 border-muted"/>
                <span class="input-group-append" @click="onSearchFilter">
                  <div class="input-group-text  rounded-right rounded-0 bg-white border-left-0 border-muted">
                    <i class="fas fa-search"></i>
                  </div>
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="header-explorer col-12 bg-light" >
      <div v-if="!myDocs" class="float-right nav py-1 h-40 d-flex justify-content-between">
        <form id="searchForm" v-on:submit.prevent="onSearchFilter">
          <div class="float-right2 d-flex" >
            <input type="text" v-model="filter"  class="form-control  rounded-left rounded-0 border-muted"/>
            <span class="input-group-append" @click="onSearchFilter">
              <div class="input-group-text  rounded-right rounded-0 bg-white border-left-0 border-muted">
                <i class="fas fa-search"></i>
              </div>
            </span>
          </div>
        </form>
      </div>
      <!-- v-if="user.rol_id == 1" -->

      <div v-if="!myDocs" id="views_type" class="float-right nav py-1 h-40 d-flex justify-content-between">
        <div class="text-secondary pt-2 pb-2">
          <i v-if="!isToggled" class="fas fa-list mr-1"></i>
          <i v-else class="fas fa-th-large mr-1"></i>
        </div>
        <base-dropdown title-classes="btn btn-secondary"
                       title="Vista documentos">
          <button @click="toggleList" type="button" class="btn-file btn mb-0 btn-light text-secondary">
            <i class="fas fa-list mr-1"></i>
            {{$t("compact_list")}}
          </button>
          <button @click="toggleMosaic" type="button" class="btn-file btn mb-0 btn-light text-secondary">
            <i class="fas fa-th-large mr-1"></i>
            {{$t("mosaic_list")}}
          </button>
        </base-dropdown>
        <label hidden class="--switch">
          <input type="checkbox">
          <span class="--slider">
            <i class="fas fa-list"></i>
            <i class="fas fa-th-large"></i>
          </span>
        </label>
      </div>
      <ul id="actions_menu" class="nav py-1 h-40 d-flex justify-content-between">
        <!-- v-if="selectFolder == 0 && this.status_folder != 0 || sfolder.active" -->
        <div class="d-flex">
          <div class="d-flex"  v-if="isAdmin || !isAdmin && selectFolder != 0">
            <li>
              <base-dropdown title-classes="btn btn-secondary"
                             title="+ Agregar">
                <button @click="onShowModalFolder" type="button" class="btn-file btn mb-0 btn-light text-secondary">
                  <i class="fas fa-folder mr-1"></i>
                  {{$t("add_folder")}}
                </button>
                <button @click="onShowModalFile" type="button" class="btn-file btn mb-0 btn-light text-secondary">
                  <i class="fas fa-file mr-1"></i>
                  {{$t("add_file")}}
                </button>
              </base-dropdown>
            </li>
            <li v-if="isMobile() && this.item.length > 0">
              <base-dropdown icon="fas fa-ellipsis-v">
                <div class="d-flex">
                  <ul class="actions_list">
                    <li class="nav-item" @click="onUnSelectAll" v-if="this.item.length > 0">
                      <button type="button" class="btn-file btn mb-0 btn-light text-secondary">
                        <i class="far fa-check-square mr-1"></i>
                        {{$t("unselect_all")}}
                      </button>
                    </li>
                    <li class="nav-item" @click="onDownloadZip" v-if="this.item.length > 0">
                      <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                        <i class="fas fa-download mr-1"></i>
                        {{$t("download")}}
                      </button>
                    </li>
                    <li class="nav-item" @click="onDeleteAllFile" >
                      <button type="button" class="btn-file btn mb-0 btn-light text-secondary">
                        <i class="fas fa-trash mr-1"></i>
                        {{$t("Eliminar")}}
                      </button>
                    </li>
                    <li class="nav-item" @click="onEditFolder" v-if="item.length == 1 && itemSelected.document_type_id == 1">
                      <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                        <i class="fas fa-info-circle mr-1"></i>
                        {{$t("properties")}}
                      </button>
                    </li>
                    <li class="nav-item" @click="onShowComments" v-if="item.length == 1 && itemSelected.document_type_id != 1">
                      <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                        <i class="fas fa-comment-alt mr-1"></i>
                        {{$t("Comments")}}
                      </button>
                    </li>
                    <li class="nav-item" @click="onShowProperties" v-if="item.length == 1 && isAdmin && itemSelected.document_type_id != 1">
                      <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                        <i class="fas fa-info-circle mr-1"></i>
                        {{$t("properties")}}
                      </button>
                    </li>
                  </ul>
                </div>
              </base-dropdown>
            </li>
            <li class="nav-item" @click="onSelectAll" v-if="this.item.length == 0">
              <button type="button" class="btn-file btn mb-0 btn-light text-secondary">
                <i class="far fa-check-square mr-1"></i>
                {{$t("select_all")}}
              </button>
            </li>
            <li class="nav-item" @click="onUnSelectAll" v-if="!isMobile() && this.item.length > 0">
              <button type="button" class="btn-file btn mb-0 btn-light text-secondary">
                <i class="far fa-check-square mr-1"></i>
                {{$t("unselect_all")}}
              </button>
            </li>
            <li class="nav-item" @click="onDownloadZip" v-if="!isMobile() && this.item.length > 0">
              <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                <i class="fas fa-download mr-1"></i>
                {{$t("download")}}
              </button>
            </li>
            <!--<li class="nav-item" @click="onDownloadZip" v-if="this.item.length > 0">
              <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                <i class="fas fa-file-archive mr-1"></i>
                {{$t("download_zip")}}
              </button>
            </li>-->
          </div>
          <div class="d-flex" v-if="!isMobile() && this.item.length > 0">
            <li class="nav-item" @click="onDeleteAllFile" >
              <button type="button" class="btn-file btn mb-0 btn-light text-secondary">
                <i class="fas fa-trash mr-1"></i>
                {{$t("Eliminar")}}
              </button>
            </li>
          </div>
          <div class="d-flex" v-if="!isMobile() && item.length == 1">
            <li class="nav-item" @click="onEditFolder" v-if="itemSelected.document_type_id == 1">
              <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                <i class="fas fa-info-circle mr-1"></i>
                {{$t("properties")}}
              </button>
            </li>
            <li class="nav-item" @click="onShowComments" v-if="itemSelected.document_type_id != 1">
              <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                <i class="fas fa-comment-alt mr-1"></i>
                {{$t("Comments")}}
              </button>
            </li>
            <li class="nav-item" @click="onShowProperties" v-if="isAdmin && itemSelected.document_type_id != 1">
              <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                <i class="fas fa-info-circle mr-1"></i>
                {{$t("properties")}}
              </button>
            </li>
            <!--<li class="nav-item" v-if="isAdmin && itemSelected.document_type_id != 1">
              <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                <i class="fas fa-download mr-1"></i>
                {{$t("download")}}
              </button>
            </li>-->
          </div>
        </div>
      </ul>
      <div v-show="!myDocs" class="">
        <div class="">
          <nav class="breadcrumbs">
            <ul id="breadcrumbs">
              <li @click="onPressRoot" class="pointer breadcrumb-item active text-uppercase font14 ">{{$t("INICIO")}} </li>
              <li v-for="(bread,index) in breadcrumbs" @click="onSelectFolder (bread)" v-bind:key="index" v-bind:class="{'text-purple': index+1 == breadcrumbs.length}" class="pointer breadcrumb-item active text-uppercase font14">{{bread.name}}</li>
              <li class="pointer text-rigth" v-if="selectFolder != 0">
                <button style="background: transparent" class="border-0 " @click="onRefresh" title="Recargar">
                  <i class="fas fa-sync-alt text-secondary"></i>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>

    <div v-show="!myDocs" class="col-12 border">
      <div class="row h-600">
        <input type="checkbox" class="menu-maker" name="menu-maker-id" id="menu-maker-id">
        <label for="menu-maker-id" class="menu-holder">
          <div class="hamburger">
            <div class="hamburger-toppings">
              <i class="fas fa-angle-double-right"></i>
            </div>
          </div>
        </label>
        <!--<input type="checkbox" id="drawer-left-toggle" name="drawer-left-toggle"/>
        <label for="drawer-left-toggle" id="drawer-left-toggle-label"></label>-->

        <input :checked="!isMobile()" type="checkbox" class="menu-maker2" name="menu-maker-id2" id="menu-maker-id2">
        <label for="menu-maker-id2" class="menu-holder2">
          <div class="hamburger">
            <div class="hamburger-toppings">
              <i class="fas fa-angle-double-left"></i>
            </div>
          </div>
        </label>

        <!--<input type="checkbox" id="drawer-right-toggle" name="drawer-right-toggle"/>
        <label v-if="selectFolder != 0 || selectDropZone != '' " for="drawer-right-toggle" id="drawer-right-toggle-label"></label>-->

        <div id="drawer_left" class="border-right d-md-block directory">
          <div class="menu-btn"></div>
          <div id="display"></div>
          <ejs-treeview v-if="show" ref="treeview" id='treeview'
                        :nodeDragStop="onDragStop"
                        :allowDragAndDrop="true"
                        :allowEditing='true'
                        :allowMultiSelection='true'
                        :fields="fields"
                        :nodeClicked='nodeClicked'
                        :nodeEdited='nodeEdited'
                        @nodeSelected="onSelectNode" >
                <ejs-contextmenu id='contentmenutree' target='#treeview' :items='menuItems' :beforeOpen='beforeopen' :select='menuclick'></ejs-contextmenu>
          </ejs-treeview>
        </div>
        <div id="page-content" class="treeview border-right">
          <div style="display:none" class="row">
            <div class="col-12">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb d-flex justify-content-between ">
                  <div class="d-flex align-items-center">
                    <li @click="onPressRoot" class="pointer breadcrumb-item active text-uppercase font14 ">{{$t("INICIO")}}</li>
                    <li v-for="(bread,index) in breadcrumbs" @click="onSelectFolder (bread)" v-bind:key="index" v-bind:class="{'text-purple': index+1 == breadcrumbs.length}" class="pointer breadcrumb-item active text-uppercase font14">{{bread.name}}</li>
                  </div>
                  <li class="pointer text-rigth" v-if="selectFolder != 0">
                    <button class="border-0 bg-gray" @click="onRefresh" title="Recargar">
                      <i class="fas fa-sync-alt text-secondary"></i>
                    </button>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div class="row px-2">
            <div id="listView" v-if="!(isToggled)" class="col-lg-12 col-md-12 col-12 px-1 pointer">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th @mouseover="selectTheader()"
                      @mouseleave="unSelectTheader()" align="left">
                    <label v-if="isMobile() || hoverTheader == true || selectAll == true" class="checkbox_label">
                      <input id="checkAll" type="checkbox" class="checkbox__input" v-model="selectAll">
                      <span class="checkbox__inner"></span>
                    </label>
                  </th>
                  <th v-for="(column,index)  in columns" v-bind:key="index">
                    <a href="#" @click.prevent=sortBy(column) :class="{ active : isActive(column) }">
                      {{$t(column+"_thd")}}
                    </a>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr :class="document === selectedItem || item.includes(document.id) ? 'active' : ''" @mouseover="selectItem(document)"
                    @mouseleave="unSelectItem()" v-for="(document,index)  in orderedDocs" v-bind:key="index">
                  <td>
                    <!--<input v-if="document === hoverItem || item.includes(document.id)"  :checked="document === itemSelected" @change="onCheckItem ($event, document)" type="checkbox" v-model="item" :value="document.id"/>-->
                    <label v-if="isMobile() || document === hoverItem || item.includes(document.id)" class="checkbox_label">
                      <input :checked="item.includes(document.id)"  @change="onCheckItem ($event, document)" type="checkbox" class="checkbox__input" v-model="item" :value="document.id"/>
                      <span class="checkbox__inner"></span>
                    </label>
                    <!--<input number type="checkbox" v-model="item" :value="document.id">-->
                  </td>
                  <td>
                    <div @click="document.document_type_id == 1 ? onSelectFolder (document) : onOpenDocument (document.id)" class="px-2 d-flex justify-content-center align-items-end">
                      <i v-if="document.document_type_id == 1" class="fas fa-folder folder-icon font30 "/>
                      <i v-else class="font30 e-list-icon font30"
                         :class="iconClass[document.document_type_id]"/>
                      <i class="far fa-comment-dots text-primary" v-if="document.comments && document.comments.length > 0"></i>
                      <span v-bind:id="'badge_list_'+document.id" v-if="document.document_type_id == 1"  class="badge bg-light">{{document.num_files}}</span>
                    </div>
                  </td>
                  <td :class="(document.active == 0) ? '':'no_active_row'">
                    <div class="ellipsis_label ellipsis first_td" @click="document.document_type_id == 1 ? onSelectFolder (document) : onOpenDocument (document.id)">
                        <span class="font12 ellipsis_text">
                          {{document.name}}
                        </span>
                    </div>
                    <div v-if="isMobile() || document === hoverItem || item.includes(document.id)" class="action_buttons">
                      <ul class="file_buttons">
                        <!--<li>
                          <button @click="onShowModalShareFolder($event, document)" type="button" class="">
                            <i class="fas fa-share-alt"></i>
                          </button>
                        </li>-->
                        <base-dropdown @change="onDropDown ($event, document)" icon="fas fa-ellipsis-v">
                          <div class="d-flex" v-if="itemSelected">
                            <ul class="actions_list">
                              <!--<li class="nav-item" @click="onEditFolder" v-if="isAdmin && itemSelected.document_type_id == 1">-->
                              <li class="nav-item" @click="onEditFolder" v-if="isAdmin && itemSelected.document_type_id == 1">
                                <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                                  <i class="fas fa-info-circle mr-1"></i>
                                  {{$t("properties")}}
                                </button>
                              </li>
                              <li class="nav-item" @click="onEditDocumentationDrop" v-if="itemSelected.document_type_id == 1">
                                <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                                  <i class="fas fa-plus text-success"></i>
                                  {{$t("item_request")}}
                                </button>
                              </li>
                              <li class="nav-item" @click="onShowComments" v-if="itemSelected.document_type_id != 1">
                                <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                                  <i class="fas fa-comment-alt mr-1"></i>
                                  {{$t("Comments")}}
                                </button>
                              </li>
                              <li class="nav-item" @click="onShowProperties" v-if="isAdmin && itemSelected.document_type_id != 1">
                                <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                                  <i class="fas fa-info-circle mr-1"></i>
                                  {{$t("properties")}}
                                </button>
                              </li>
                              <li class="nav-item" >
                                <button @click="onShowModalShareFolder($event, document)" type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                                  <i class="fas fa-share mr-1"></i>
                                  {{$t("show_path")}}
                                </button>
                              </li>
                              <li class="nav-item" v-if="isAdmin && itemSelected.document_type_id != 1" @click="onDownloadFile" >
                                <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                                  <i class="fas fa-download mr-1"></i>
                                  {{$t("descargar")}}
                                </button>
                              </li>
                              <li class="nav-item" @click="onDeleteFile" >
                                <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                                  <i class="fas fa-trash mr-1"></i>
                                  {{$t("eliminar")}}
                                </button>
                              </li>
                              <!--<li class="nav-item" >
                                <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                                  <i class="fas fa-info-circle mr-1"></i>
                                  {{$t("administrar_acceso")}}
                                </button>

                              </li>
                              <li class="nav-item" >
                                <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                                  <i class="fas fa-info-circle mr-1"></i>
                                  {{$t("mover_a")}}
                                </button>

                              </li>
                              <li class="nav-item" >
                                <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                                  <i class="fas fa-info-circle mr-1"></i>
                                  {{$t("copiar_a")}}
                                </button>

                              </li>
                              <li class="nav-item" >
                                <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                                  <i class="fas fa-info-circle mr-1"></i>
                                  {{$t("avisarme")}}
                                </button>
                              </li>-->
                              <!--<li class="nav-item" >
                                <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                                  <i class="fas fa-info-circle mr-1"></i>
                                  {{$t("detalles")}}
                                </button>

                              </li>-->
                              <!--<li class="nav-item" @click="onDownloadZip">
                                <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                                  <i class="fas fa-download mr-1"></i>
                                  {{$t("download")}}
                                </button>
                              </li>-->
                            </ul>
                          </div>
                        </base-dropdown>
                      </ul>
                    </div>
                  </td>
                  <td :class="(document.active == 0) ? '':'no_active_row'">
                    <div>
                        <span class="font12 text-uppercase">
                          {{formatDate2(document.updated_at)}}
                        </span>
                    </div>
                  </td>
                  <td :class="(document.active == 0) ? '':'no_active_row'">
                    <div>
                        <span class="font12 text-uppercase">
                          {{document.author ? document.author["name"] : '&nbsp;'}}
                        </span>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
              <pre style="display: none">
                {{ $data['selectEditDocFolder'] }}
              </pre>
              <pre style="display: none">
                {{ $data['selected'] }}
              </pre>
              <pre style="display: none">
                {{ $data['itemSelected'] }}
              </pre>
            </div>
            <div v-else id="gridView" class="col-lg-12">
              <div class="row d-flex align-items-center">
                <div @mouseover="selectItem(document)"
                     @mouseleave="unSelectItem()" class="col px-1 pointer mosaicBox" v-for="(document,index) in documents"  v-bind:key="index">
                  <!--<input type="checkbox" @change="onCheckItem ($event, document)" v-if="isAdmin && document.document_type_id == 1 || document.document_type_id != 1" class="ml-3" v-model="item" :value="document.id">-->
                  <label v-if="isMobile() || document === hoverItem || item.includes(document.id)" class="checkbox_label">
                    <input :checked="item.includes(document.id)"  @change="onCheckItem ($event, document)" type="checkbox" class="checkbox__input" v-model="item" :value="document.id"/>
                    <span class="checkbox__inner"></span>
                  </label>
                  <!--<input type="checkbox" @change="onCheckItem ($event, document)" class="ml-3 mosaic_checkbox" v-model="item" :value="document.id">-->

                  <div @click="document.document_type_id == 1 ? onSelectFolder (document) : onOpenDocument (document.id)">
                    <div class="d-flex justify-content-center align-items-end">
                      <!--<i v-if="document.document_type_id == 1" data-icon-name="folderCoverLargeDefaultBack" aria-hidden="true" class="ms-FolderCover-back back_folder"><img src="https://res-1.cdn.office.net/files/fabric-cdn-prod_20220127.003/office-ui-fabric-react-assets/foldericons/lg-bg.svg"></i>
                      <i v-if="document.document_type_id == 1" data-icon-name="folderCoverLargeDefaultFront" aria-hidden="true" class="ms-FolderCover-front front_folder"><img src="https://res-1.cdn.office.net/files/fabric-cdn-prod_20220127.003/office-ui-fabric-react-assets/foldericons/lg-fg.svg"></i>-->
                      <i v-if="document.document_type_id == 1" class="fas fa-folder folder-icon font50 "/>
                      <i v-else class="font50 e-list-icon"
                         :class="iconClass[document.document_type_id]"/>
                      <i class="far fa-comment-dots text-primary " v-if="document.comments && document.comments.length > 0"></i>
                      <span v-bind:id="'badge_'+document.id" v-if="document.document_type_id == 1"  class="badge bg-light">{{document.num_files}} </span>
                    </div>
                    <div :class="(document.active == 0) ? '':'no_active_row'" class="text-center ellipsis" >
                        <span class="font12">
                          {{document.name}}
                        </span>
                    </div>
                    <div :class="(document.active == 0) ? '':'no_active_row'" class="text-center">
                        <span class="font12 text-uppercase">
                        {{formatDate2(document.updated_at)}}
                        </span>
                    </div>
                    <div :class="(document.active == 0) ? '':'no_active_row'" class="text-center">
                        <span class="font12 text-uppercase">
                      {{document.author ? document.author["name"] : '&nbsp;'}}
                        </span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div id="drawer_right">
          <div class="request d-sm-block" v-if="selectFolder != -1" >

            <div class="border-bottom">
              <ul class="drawer_right_tabs nav nav-tabs">
                <li class="nav-item" >
                  <span class="nav-link2" @click="fileView=1" v-bind:class="{'active' : fileView==1}"><i class="fas fa-upload fa-fw"></i>{{$t("documents_tabs")}}</span>
                </li>
                <li v-if="itemSelected" class="nav-item">
                  <span class="nav-link2" @click="fileView=2" v-bind:class="{'active' : fileView==2}"><i class="fas fa-clipboard-list fa-fw"></i>{{$t("solicitud_tabs")}}</span>
                </li>
                <li v-if="item.document_type_id == 1 && item.length == 1 ||  fileView == 2 && itemSelected">
                  <button style="background-color: transparent" class="border-0" @click="onEditDocumentation" v-if="isAdmin">
                    <i class="far fa-edit fa-fw text-secondary"></i>
                  </button>
                </li>
              </ul>
              <ul style="display: none" class="nav nav-tabs">
                <li class="nav-item border rounded-top" >
                  <span class="nav-link" @click="fileView=1" v-bind:class="{'active' : fileView==1}"><i class="fas fa-file-upload fa-fw"></i>{{$t("documents_tabs")}}</span>
                </li>
                <li class="nav-item border rounded-top" v-if="request_documentation.length > 0">
                  <span class="nav-link" @click="fileView=2" v-bind:class="{'active' : fileView==2}"><i class="fas fa-copy fa-fw"></i>{{$t("solicitud_tabs")}}</span>
                </li>
                <!--<li class=" p-2 d-flex justify-content-end" v-if="item.length == 1 &&  request_documentation.length >= 0 &&  fileView == 2">
                  <button class="border-0 btn-xs" @click="onEditDocumentation" v-if="isAdmin">
                    <i class="fas fa-plus text-success"></i>
                    {{$t("Add")}}
                  </button>
                </li>-->
                <li class=" p-2 d-flex justify-content-end" v-if="item.document_type_id == 1 && item.length == 1 || request_documentation.length > 0 &&  fileView == 2">
                  <button class="border-0 btn-xs" @click="onEditDocumentation" v-if="isAdmin">
                    <i class="fas fa-plus text-success"></i>
                    {{$t("Edit")}}
                  </button>
                </li>
              </ul>
            </div>
            <div  class="col-12 px-0 contentListItem ">
              <div v-if="fileView == 1">
                <vue-dropzone ref="dropzone" id="dropzone"
                              :options="dropzoneOptions"
                              :include-styling="true"
                              v-on:vdropzone-success="uploadFileSuccess"
                              v-on:vdropzone-complete="fileComplete"
                              v-on:vdropzone-canceled="cancelFile"
                              v-on:vdropzone-queue-complete="UploadSuccess"
                              v-on:vdropzone-sending="sendingEvent"></vue-dropzone>
              </div>
              <div class="row itemRequest px-3" v-else-if="fileView == 2"  v-for="(item, key) in request_documentation" v-bind:key="key" >
                <div class="col-12 bg-light d-flex align-items-center font-weight-bold" v-if="item.isIndex" >
                  <span  class="font14 text-primary ">
                    {{key + 1}}. {{item.name}}
                  </span>
                </div>
                <div class="col-12 d-flex align-items-center pl-2 pr-1 py-1" v-else>
                  <div class="w-100">
                    <div class="d-flex justify-content-between align-items-center">
                      <span class="item-request" @click="onSelectItemRequest (item)"><!--{{key + 1}}. -->{{item.name}}</span>
                      <div class="text-center col-2 p-0">
                        <i title="Eliminar" v-if="item.request_doc.length > 0" class="fas fa-eraser pointer text-warning mr-2 text16" @click="onRemoveRequest (item)"></i>
                        <i title="Asignar" class="fas fa-paperclip pointer text-info text16" @click="onSelectRequest (item)"></i>
                      </div>
                    </div>
                    <div class="d-flex mr-3 font12 text-uppercase justify-content-between" v-if="item.request_doc.length > 0" v-bind:key="key">
                      <label> <i class="fas fa-paperclip mr-2"></i> {{item.request_doc [0].user.name}}</label>
                      <label> {{$t("recibido")}}</label>
                      <!--<label>{{$moment(item.request_doc [0].created_at).fromNow()}}</label>-->
                      <label>{{$moment(item.request_doc [0].created_at).format("DD/MM/YYYY")}}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div style="display:none; position: absolute; top: 0" v-if="item.document_type_id == 1 && item.length == 1 || request_documentation.length > 0 &&  fileView == 2">
                <button class="border-0 btn-xs" @click="onEditDocumentation" v-if="isAdmin">
                  <i class="far fa-edit fa-fw text-info"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="myDocs" class="col-12 boder">
      <div id="my_documents_list" class="col-lg-12 col-md-12 col-12 px-1 pointer">
        <table id="clientsDocs" class="table table-hover">
          <thead>
          <tr>
            <th @mouseover="selectTheader()"
                @mouseleave="unSelectTheader()" align="left">
              <label v-if="isMobile() || hoverTheader == true || selectAll == true" class="checkbox_label2">
                <input id="checkAll" type="checkbox" class="checkbox__input" v-model="selectAll2">
                <span class="checkbox__inner"></span>
              </label>
            </th>
            <th v-for="(column,index)  in columns2" v-bind:key="index">
              <a href="#" @click.prevent=sortBy(column) :class="{ active : isActive(column) }">
                {{$t(column+"_thd")}}
              </a>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr :class="document === selectedItem || item.includes(document.id) ? 'active' : ''" @mouseover="selectItem(document)"
              @mouseleave="unSelectItem()" v-for="(document,index)  in orderedDocsUser" v-bind:key="index">
            <td>
              <!--<div class="custom-control custom-checkbox">
                <input v-on:click="toggleChecklist(document.id,$event, index)"
                    v-model="selectedItems"
                    type="checkbox"
                    :value="document.id"
                    class="custom-control-input"
                    :id="'checkbox_'+document.id">
                <label class="custom-control-label" :for="'checkbox_'+document.id"><span class="text-hide">Check</span></label>
              </div>-->
              <div class="custom-control custom-checkbox">
                <label v-if="isMobile() || document === hoverItem || item.includes(document.id)" class="checkbox_label">
                  <input v-on:click="toggleChecklist(document.id,$event, index)"
                         :checked="item.includes(document.id)"
                         @change="onCheckItem ($event, document)"
                         v-model="item"
                         type="checkbox"
                         :value="document.id"
                         class="checkbox__input"
                         :id="'checkbox_'+document.id"/>
                  <span class="checkbox__inner"></span>
                </label>
              </div>
            </td>
            <td>
              <div @click="document.document_type_id == 1 ? onSelectFolder (document) : onOpenDocument (document.id)" class="px-2 d-flex justify-content-center align-items-end">
                <i v-if="document.document_type_id == 1" class="fas fa-folder folder-icon font30 "/>
                <i v-else class="font30 e-list-icon font30"
                   :class="iconClass[document.document_type_id]"/>
                <i class="far fa-comment-dots text-primary" v-if="document.comments && document.comments.length > 0"></i>
                <span v-bind:id="'badge_list_'+document.id" v-if="document.document_type_id == 1"  class="badge bg-light">{{document.num_files}}</span>
              </div>
            </td>
            <td :class="(document.active == 0) ? '':'no_active_row'">
              <div class="ellipsis_label ellipsis first_td" @click="document.document_type_id == 1 ? onSelectFolder (document) : onOpenDocument (document.id)">
                  <span class="font12 ellipsis_text">
                    {{document.name}}
                  </span>
              </div>
              <div v-if="isMobile() || document === hoverItem || item.includes(document.id)" class="action_buttons">
                <ul class="file_buttons">
                  <!--<li>
                    <button @click="onShowModalShareFolder($event, document)" type="button" class="">
                      <i class="fas fa-share-alt"></i>
                    </button>
                  </li>-->
                  <base-dropdown @change="onDropDown ($event, document)" icon="fas fa-ellipsis-v">
                    <div class="d-flex" v-if="itemSelected">
                      <ul class="actions_list">
                        <!--<li class="nav-item" @click="onEditFolder" v-if="isAdmin && itemSelected.document_type_id == 1">-->
                        <li class="nav-item" @click="onEditFolder" v-if="isAdmin && itemSelected.document_type_id == 1">
                          <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                            <i class="fas fa-info-circle mr-1"></i>
                            {{$t("properties")}}
                          </button>
                        </li>
                        <li class="nav-item" @click="onEditDocumentationDrop" v-if="itemSelected.document_type_id == 1">
                          <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                            <i class="fas fa-plus text-success"></i>
                            {{$t("item_request")}}
                          </button>
                        </li>
                        <li class="nav-item" @click="onShowComments" v-if="itemSelected.document_type_id != 1">
                          <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                            <i class="fas fa-comment-alt mr-1"></i>
                            {{$t("Comments")}}
                          </button>
                        </li>
                        <li class="nav-item" @click="onShowProperties" v-if="isAdmin && itemSelected.document_type_id != 1">
                          <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                            <i class="fas fa-info-circle mr-1"></i>
                            {{$t("properties")}}
                          </button>
                        </li>
                        <li class="nav-item" >
                          <button @click="onSelectPathFolder (itemSelected)" type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                            <i class="fas fa-share mr-1"></i>
                            {{$t("Ver Ruta")}}
                          </button>
                        </li>
                        <li class="nav-item" v-if="isAdmin && itemSelected.document_type_id != 1" @click="onDownloadFile" >
                          <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                            <i class="fas fa-download mr-1"></i>
                            {{$t("descargar")}}
                          </button>
                        </li>
                        <li class="nav-item" @click="onDeleteFile" >
                          <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                            <i class="fas fa-trash mr-1"></i>
                            {{$t("eliminar")}}
                          </button>
                        </li>
                        <!--<li class="nav-item" >
                          <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                            <i class="fas fa-info-circle mr-1"></i>
                            {{$t("administrar_acceso")}}
                          </button>

                        </li>
                        <li class="nav-item" >
                          <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                            <i class="fas fa-info-circle mr-1"></i>
                            {{$t("mover_a")}}
                          </button>

                        </li>
                        <li class="nav-item" >
                          <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                            <i class="fas fa-info-circle mr-1"></i>
                            {{$t("copiar_a")}}
                          </button>

                        </li>
                        <li class="nav-item" >
                          <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                            <i class="fas fa-info-circle mr-1"></i>
                            {{$t("avisarme")}}
                          </button>
                        </li>-->
                        <!--<li class="nav-item" >
                          <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                            <i class="fas fa-info-circle mr-1"></i>
                            {{$t("detalles")}}
                          </button>

                        </li>-->
                        <!--<li class="nav-item" @click="onDownloadZip">
                          <button type="button" class="btn-file btn mb-0 btn-light text-secondary" >
                            <i class="fas fa-download mr-1"></i>
                            {{$t("download")}}
                          </button>
                        </li>-->
                      </ul>
                    </div>
                  </base-dropdown>
                </ul>
              </div>
            </td>
            <td @click="onSelectPathFolder (document)" :class="(document.active == 0) ? '':'no_active_row'">
              <div>
                        <span class="font12 text-uppercase">
                          {{(document.folder_code)}}
                        </span>
              </div>
            </td>
            <td :class="(document.active == 0) ? '':'no_active_row'">
              <div>
                        <span class="font12 text-uppercase">
                          {{formatDate2(document.updated_at)}}
                        </span>
              </div>
            </td>
            <td :class="(document.active == 0) ? '':'no_active_row'">
              <div>
                        <span class="font12 text-uppercase">
                          {{document.author ? document.author["name"] : '&nbsp;'}}
                        </span>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <modal v-if="showShareModal" :showClose="true" classContent="contentFolder" @close="showShareModal=false" :showBtnCancel="false" @accept="document_type == 1 ? onSaveFolder () : onUploadDocument ()" :title="titleModal" :FlText="$t('Cancelar')" :size="'md'" :btnAcceptText="$t('Compartir')">
      <div class="circle_share">
        <span class="btn2 btn-file2 text-white copy-btn ml-auto" @click.stop.prevent="copyLinkPath"><i class="fas fa-link" style="color:#cdcdcd;font-size: 48px;"></i></span>
        <input type="hidden" id="path-code" :value=" (getDocument(item).url != null) ? getDocument(item).url : '1234'">
      </div>
      <hr>
      {{getDocument(item).document_type_id != 1 ?  'File':'Folder'}}
      <span class="label_share">Compartido con:</span>
    </modal>

    <modal v-if="showModalRequiredDoc" :showClose="true" classContent="contentFolder" @close="showModalRequiredDoc=false" :showBtnCancel="false" @accept="document_type == 1 ? onSaveEditFolder () : onUploadDocument ()" :title="titleModal" :FlText="$t('Cancelar')" :size="'lg'" :btnAcceptText="$t('Guardar')">

      <div class="col-12">
        <base-select @change="onSelectTemplate" v-model="template_id" :items="templates" :label="$t('template')">
        </base-select>
      </div>
      <div class="d-flex align-items-end">
        <!--<div class="d-flex align-items-end" v-if="id">-->
        <div class="col-9">
          <base-input type="text" autocomplete="false" v-model="item_request"/>
        </div>
        <div class="col-3 pl-0">
          <button class="btn btn-secondary btn-fill w-100" @click="onAddRequest">
            {{$t("add")}}
          </button>
        </div>
      </div>

      <div style="display: none">
        {{request_items}}
      </div>
      <div class="col-12 mt-2 contentItems" v-if="request_items.length > 0">
        <draggable
            :list="request_items"
            :disabled="!enabled"
            class="list-group"
            ghost-class="ghost"
            @change="log"
            @start="dragging = true"
            @end="dragging = false"
        >
          <div class="list-group-item d-flex justify-content-between align-items-center px-3 py-1"  v-for="(element,index) in request_items" :key="index" v-bind:class="{'bg-gray titleColor' : element.isIndex}">
            <div v-show="editOffset != index"
                 class="list-group-item-heading">
              <a href="#" @click.prevent="startEditing(index)">
                <i class="fas fa-edit"></i>
              </a>
              <span>{{ element.name }}</span>
            </div>
            <input v-show="editOffset==index" type="text"
                   :id = "'item-user-'+index"
                   @keydown.enter="updatePost" @keydown.esc="cancelEditing"
                   class="form-control" v-model="editPost.name">
            <div>
              <button class="btn border-0 text-danger py-1" @click="deleteEvent (element, index)">
                <i class="fas fa-times-circle"></i>
              </button>
            </div>
          </div>
        </draggable>
      </div>
    </modal>

    <modal id="folderModal" v-if="showModal" :showClose="true" classContent="contentFolder" @close="showModal=false; showFolderTree = false;" :showBtnCancel="false" @accept="document_type == 1 ? onSaveFolder () : onUploadDocument ()" :title="titleModal" :FlText="$t('Cancelar')" :size="'lg'" :btnAcceptText="$t('Guardar')">
      <div v-if="document_type == 1">
        <div class="col-12" >
          <base-input id="folderName" @input="createFolderCode()" type="text" :validated="$v.name.$error" :label="$t('name_folder')" autocomplete="false" v-model="name">
            <template v-slot:textError v-if="$v.name.$error && !$v.name.required"> {{$t('Campo_requerido')}}</template>
          </base-input>
        </div>
        <hr />
        <div v-show="isAdmin" class="col-12">
          <div class="check_noti form-group">
            <label for="toggle_folder">Notificaciones a usuarios
              <input type="checkbox" id="toggle_folder" @click="toggleFolderTree">
            </label>
          </div>
          <div v-show="showFolderTree" class="form-group">
            <!--<span>Checked Ids: {{ checkedUsersId }}</span>-->
            <div class="users_folder_list">
              <table width="100%">
                <tr v-for="(user) in users_folder" :key="user.id">
                    <td>
                        <!--<span>{{user}}</span>-->
                        <div style="float: left">
                          <input :id="user.id" :value="user.id" v-model="checkedUsersId" @click="selectUserCheck($event)" type="checkbox" />
                          <span></span>
                        </div>
                        <label :for="user.id">
                          {{user.name}}<br><span :key="index" class="italic_">{{user.email}}</span>
                        </label>
                    </td>
                </tr>
                <!--<tr>
                  <td>Let my friends see my email address</td>
                  <td>
                    <div>
                      <input type="checkbox" checked="" />
                      <span></span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <input type="submit" value="Save Settings" >
                  </td>
                </tr>-->
              </table>
            </div>
           <!--<l-table class="mb-5"
                     :columns="table.columnsUser"
                     :data="users_folder">
            </l-table>
            <ul>
              <li><label><input type="checkbox" :checked="isAllSelected" @click="selectAllUsers">Select All</label></li>
              <li v-for="(user, index) in users_folder" :key="user.id">
                <label><input type="checkbox" v-model="selectedUserIds" :value="user.id" @click="select">{{index}}.{{user.name}}</label>
              </li>
            </ul>-->
          </div>
        </div>
        <!--<div v-if="isAdmin">
          <div class="col-12" >
            <base-input type="text" :label="$t('folder_code')" autocomplete="false" v-model="folder_code">
            </base-input>
          </div>
          <div class="col-12">
            <div v-if="itemSelected" class="row">
              <div class="col-3">
                <div>
                  <span class="font-weight-bold accordion-header-title">{{$t("SOLO LECTURA")}}</span>
                </div>
              </div>
              <div class="col-9">
                <base-checkbox v-if="itemSelected" v-model="$v.active" :checked="itemSelected.active ? true : false"  @input="toggleActiveCheckBox (itemSelected)" />
              </div>
            </div>
          </div>
          <div class="col-12" style="display: none" >
            <base-input type="text" :label="$t('folder_code')" autocomplete="false" v-model="folder_code">
            </base-input>
          </div>
        </div>-->
      </div>
      <div v-else>
        <div class="col-12 my-2">
          <div>
            <input id="file" class="d-none" multiple type="file" accept=".pdf,.jpeg,.jpg,.png,.gif,.mp4,.zip,.mp3,.txt,.doc,.xls,.ppt,.docx,.xlsx,.pptx,.csv" @change="_onFileUpload" />
            <label for="file">
              <div class="flex items-center text-dark bg-light px-4 py-2 mb-2">
                <i class="fas fa-upload text-sm"></i>
                <span class="ml-3">{{$t("selected_file")}}</span>
              </div>
            </label>
            <div class="invalid-feedback" v-if="error">{{$t('Campo_requerido')}}</div>
          </div>
          <div class="w-full boder-dashed p-1 d-flex justify-content-between align-items-center mb-1 " v-for="(file,key) in files" v-bind:key="key">
            <div>
              <i class="fas fa-file bg-warning p-2 opacity"></i>
              <span class="ml-2 fileText">{{file.name}}</span>
            </div>
            <i class="fas fa-times-circle text-danger px-2" @click="_onRemoveFile(key)"></i>
          </div>
        </div>
      </div>
    </modal>
    <modal v-if="showModalComments" :classContent="'bg-light'" :showfooter="false" :showClose="true" :title="this.$t('Comments')" :size="'lg'" @close="onCloseModal">
      <div class="row px-2 py-1">
        <div class="col-12 mb-1" style="height: 400px; overflow:scroll">
          <!-- <label >{{$t("comment")}}</label> -->
          <div v-if="comments.length > 0" class="mb-4">
            <div class="row mb-3" v-for="(item, index) in comments" v-bind:key="index">
              <div class="col-lg-1 col-2 px-0 d-flex align-items-start justify-content-center" >
                        <span class="p-25 bg-dark text-center text-white font-weight-bold rounded-circle text-uppercase" v-if="item.user" :title="item.user.name">
                          {{getInitials (item.user.name)}}
                        </span>
              </div>
              <div class="col-lg-11 col-10 alert alert-info rounded text-dark mb-1" >{{item.comment}}</div>
              <div class="col-12 text-right font12">{{item.created_at | moment("calendar")}}</div>
            </div>
          </div>
          <div class="border border-bottom-0 text-center p-5" v-else>
            <span>{{$t("sn_comments")}}</span>
          </div>
          <textarea class="form-control" v-model="comment_text" rows="2"></textarea>
          <div class="invalid-feedback" v-if="error_comment">
            {{$t("Campo_requerido")}}
          </div>
        </div>

       <!-- <span>Checked Ids: {{ checkedUsersId }}</span>-->
        <div class="col-12 text-right">
          <button class="btn btn-primary btn-fill" @click="onSaveComment">
            <i class="fas fa-paper-plane"></i>
            {{$t("Comentar")}}
          </button>
        </div>
      </div>
    </modal>
    <modal v-if="showProperties" :data="docProperties" :showfooter="true"  :showClose="true" :title="this.$t('properties')" :size="'md'" :btnAcceptText="$t('Guardar')" :showBtnCancel="false" @close="showProperties=false" @accept="onRefresh ();onLoadFolders ();showProperties=false">
      <step-document style="display: none" :document="itemSelected"  @refreshStatus="onShowProperties"></step-document>

      <div class="col-12 pr-0 pl-0 d-flex align-items-center accordion-header justify-content-between" >
        <div>
          <span class="font-weight-bold accordion-header-title">{{$t("SOLO LECTURA")}}</span>
        </div>
        <div class="checkStep">

          <base-checkbox :checked="itemSelected.active ? true : false" @input="toggleActiveCheckBox (itemSelected)" />
          <!--<label class="switch">
            <input :checked="itemSelected.active ? true : false" ref="activeSelected" type="checkbox" @click="toggleActiveCheckBox (itemSelected)">
            <div class="slider round"></div>
          </label>-->
        </div>
      </div>
      <div class="col-12 pr-0 pl-0 d-flex align-items-center accordion-header justify-content-between" >
        <div>
          <span class="font-weight-bold accordion-header-title">{{$t("RUTA")}}</span>
        </div>
        <div class="checkStep">
          {{this.onPrintBreadcrumb()}}
        </div>
      </div>

    </modal>
    <dialog-loader v-if="showProgress" :progress="progress"  ref="dialogLoader"></dialog-loader>
  </div>
</template>
<script>
import $ from 'jquery';
import _ from 'lodash';
import moment from 'moment';
//import Accordion from "@/components/Accordion.vue";
import Modal from "@/components/Modal.vue";
import StepDocument from "@/components/StepDocument.vue";
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import dialogLoader from "@/components/dialogLoader.vue";
import draggable from 'vuedraggable';
import vue2Dropzone from 'vue2-dropzone';
const vuex = JSON.parse (localStorage.getItem ('vuex'));
const token = `Bearer ${vuex.login.token}`;
const tableColumns = ['request_type', 'insolvency', 'honoraries', 'created_at' , 'status', 'options', 'download'];

export default {
  computed: {
    selectAll: {
      get: function () {
        return this.documents ? this.item.length == this.documents.length : false;
      },
      set: function (value) {
        var selected = [];

        if (value) {
          this.documents.forEach(function (user) {
            selected.push(user.id);
          });
        }

        this.item=selected;

        //this.selected = selected;
      }
    },
    selectAll2: {
      get: function () {
        return this.documentsUser ? this.item.length == this.documentsUser.length : false;
      },
      set: function (value) {
        var selected = [];

        if (value) {
          this.documentsUser.forEach(function (user) {
            selected.push(user.id);
          });
        }

        this.item=selected;

        //this.selected = selected;
      }
    },
    orderedDocs: function(){
      return _.orderBy(this.documents, this.sortKey, this.reverse ? "asc" : "desc");
      //return this.users;
    },
    orderedDocsUser: function(){
      return _.orderBy(this.documentsUser, this.sortKey, this.reverse ? "asc" : "desc");
      //return this.users;
    },
    /*selectAll: {
      get: function () {
        console.log(this.selected.length);
        return this.item ? this.selected.length == this.item.length : false;
      },
      set: function (value) {
        var selected = [];

        if (value) {
          this.item.forEach(function (user) {
            selected.push(user.id);
          });
        }

        this.selected = selected;
      }
    },
    orderedDocs: function(){
      //return _.orderBy(this.documents, this.sortKey, this.reverse ? "asc" : "desc");
      return this.item.slice().sort();
    },*/
    ...mapGetters({
      user: 'login/user',
    })
  },
  data ()
  {
    return {

      table:
          {
            columns: [...tableColumns],
            columnsAttachment :
                [
                  'name',
                  'created_at',
                  'url'
                ],
            columnsUser :
                [
                  'name',
                  'position',
                  'Email',
                  'active',
                  'edit_event',
                  'delete_event'
                ]
          },
      tableAttachment : [],
      users_folder: this.getUsersFolder(),
      isAllSelected: false,
      selectedUserIds: [1,2],
      checkedUsersId: [],
      menuItems : [
        { text: 'Añadir Carpeta' },
        { text: 'Renombrar Carpeta' },
        { text: 'Borrar Carpeta' }
      ],
      index : 1,
      iconClass: {
        2 : 'e-fe-pdf',
        3 : 'e-fe-docx',
        4 : 'e-fe-image',
        5 : 'e-fe-zip',
        6 : 'e-fe-pptx',
        7 : 'e-fe-xlsx',
        8 : 'e-fe-music',
        9 : 'e-fe-video',
        10 : 'e-fe-txt',
      },
      fileTypes: {
        'application/pdf' : 2,
        'image/bmp'       : 4,
        'image/jpg'       : 4,
        'image/jpeg'      : 4,
        'image/png'       : 4,
        'image/gif'       : 4,
        'video/mp4'       : 9,
        'audio/mpeg'      : 8,
        'audio/mp3'       : 8,
        'text/plain'      : 10,
        'application/zip' : 5,
        'application/x-zip-compressed' : 5,
        'application/msword' : 3,
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document' : 3,
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template' : 3,
        'application/vnd.oasis.opendocument.spreadsheet' : 3,
        'application/vnd.oasis.opendocument.text' : 3,
        'application/rtf' : 3,
        'application/vnd.ms-powerpoint' : 6,
        'application/vnd.openxmlformats-officedocument.presentationml.presentation' : 6,
        'application/vnd.ms-excel'  : 7,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'  : 7,
        'application/vnd.ms-excel.sheet.macroEnabled.12' : 7,
        'text/csv'  : 7
      },
      dropzoneOptions2:{
        // url: 'http://localhost/clevergestweb/public/api/v1/documents/upload_file',
        url: '/public/api/v1/documents/upload_file',
        addRemoveLinks: true,
        removeFile:true,
        //previewTemplate: this.template(),
        //includeStyling: true,
        maxFilesize: 50,
        createImageThumbnails: true,
        autoProcessQueue: true,
        autoQueue: true,
        dictCancelUploadConfirmation : "¿Estás seguro de que deseas cancelar esta carga?",
        dictDefaultMessage: "<i class='fas fa-file-upload mr-2'></i>Arrastre el archivo",
        headers: { "Authorization": token }
      },
      dropzoneOptions: {
        // url: 'http://localhost/clevergestweb/public/api/v1/documents/upload_file',
        url: '/public/api/v1/documents/upload_file',
        thumbnailWidth: 75,
        thumbnailHeight: 75,
        addRemoveLinks: true,
        removeFile:true,
        //previewTemplate: this.template(),
        //includeStyling: true,
        maxFilesize: 50,
        createImageThumbnails: true,
        autoProcessQueue: true,
        autoQueue: true,
        dictCancelUploadConfirmation : "¿Estás seguro de que deseas cancelar esta carga?",
        dictDefaultMessage: "<i class='fas fa-file-upload mr-2'></i>Arrastre el archivo",
        headers: { "Authorization": token }
      },
      enabled: true,
      isIndex : false,
      dragging: false,
      folders : [],
      showModal : false,
      showShareModal: false,
      document_type : null,
      name : null,
      error : false,
      files : [],
      selectFolder : 0,
      selectEditDocFolder: 0,
      selectDropZone: 0,
      sfolder : {},
      documents : [],
      itemSelected : null,
      itemDocRequired: null,
      item : [],
      request_documentation : [],
      breadcrumbs : [],
      isAdmin : false,
      comments : [],
      showModalComments : false,
      comment_text : null,
      error_comment : false,
      document_status : [],
      showProperties : false,
      checkedNodes : [],
      show: false,
      docProperties : null,
      filter : "",
      folder_code : null,
      progress : 0,
      directory : [],
      showProgress : false,
      templates : [],
      request_id : [],
      template_id : null,
      request_items : [],
      item_request : null,
      itemRequestSelected : null,
      documentResp  : [],
      changeTemplate : false,
      fileView : 1,
      CheckedTypes    : [],
      statusFilter      : "all",
      checkedItem : false,

      endpoint: "client_documents",
      section: "/admin/documentos",
      urlDownload: "/document/download/",
      columnsUser: ["check_all", "file_type", "file_name", "user", "updated_at","path", "show_file", "download_file"],
      columnsRequest : ["name", "delete_event"],
      fields: {
        dataSource : {},
        id: 'id',
        parentID: 'parent_id',
        text: 'name',
        iconCss: 'icon',
        child: 'subChild', htmlAttributes: 'hasAttribute',
        hasChildren: 'hasChild'
      },
      selected: [],
      //selectAll: false,
      isToggled: false,
      //columns: ["tipo", "nombre", "modificado", "usuario"],
      columns: ["document_type_id", "name", "updated_at", "user"],
      columns2: ["document_type_id", "name", "folder_code", "updated_at", "user"],
      //columns: ["name", "email", "age"],
      users: [/*
        { "id": "1", "age": 21, "name": "Shad Jast", "email": "pfeffer.matt@yahoo.com" },
        { "id": "2", "age": 45, "name": "Duane Metz", "email": "mohammad.ferry@yahoo.com" },
        { "id": "3", "age": 34, "name": "Myah Kris", "email": "evolkman@hotmail.com" },
        { "id": "4", "age": 19, "name": "Dr. Kamron Wunsch", "email": "lenora95@leannon.com" },
        { "id": "5", "age": 29, "name": "David Pella", "email": "lenora95@leannon.com" },
        { "id": "6", "age": 27, "name": "Richard Jacob", "email": "richard.jacob@leannon.com" }*/] ,
      sortKey: "",
      reverse: false,
      search: "",
      selectedItem: false,
      hoverItem: false,
      hoverTheader:false,
      pathCopy:'',
      showModalRequiredDoc:false,
      editOffset: -1,
      editPost: {},
      editPostOri: {},
      count: 0,
      //checkbox: false,
      checkboxes: ['Opt 1', 'Opt 2', 'Opt 3', 'Opt 4'],
      checkbox: [],
      onOff: true,
      myDocs:false,
      //userDocs: this.getMyDocs(),
      tableData: [],
      documentsUser:[],

      dataTable: null,
      selectedItems:[],
      savedIndex: null,

      checkedNames: [],
      showFolderTree:false,

      parent_folder:0,
    }
  },
  watch : {
    indexFolder : function (newVal)
    {
      this.documents = newVal;
    }
  },
  components : {
    Modal,
    StepDocument,
    dialogLoader,
    draggable,
    vueDropzone: vue2Dropzone
  },
  props : {
    indexFolder   : Array,
    root          : String,
    title         : String
  },
  created ()
  {
    this.documents = this.indexFolder;
    this.folders = this.indexFolder;
    this.isAdmin = this.user.rol_id == 1;
    this.onLoadDocumentStatus ();
    this.onLoadFolders ();
    this.loadTemplateDocumentation ();
  },
  updated ()
  {
    if (this.selectFolder == 0) this.folders = this.documents;

  },
  validations ()
  {
    return {
      name: {
        required
      }
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  methods : {
    loadData(){
      console.log("loadData");
    },
    getUsersFolder (){
      setTimeout (() => {
        let data = {
          contact_id: this.user.client.id,
        };
        //this.users_folder =[];
        this.checkedUsersId = [];
        this.$axios.post ("document/folder_users",data)
          .then ((response) => {
            console.log(response.data);
            this.users_folder = response.data;
          })
          .catch (() => {
            this.$store.dispatch ('isLoadingOff');
          });
      }, 100);

    },
    selectAllUsers () {
      if (this.isAllSelected) {
        this.selectedUserIds = []
        this.isAllSelected = false
      } else {
        this.selectedUserIds = []
        for (var user in this.users_folder) {
          this.selectedUserIds.push(this.users_folder[user].id)
        }
        this.isAllSelected = true
      }
    },
    selectUsers () {
      if (this.selectedUserIds.length !== this.users_folder.length) {
        this.isAllSelected = false
      } else {
        this.isAllSelected = true
      }
    },
    toggleChecklist: function(checklistId, evt, index){

      const savedIndex = this.savedIndex;
      this.savedIndex = index;

      // If this is the first pass or no shift key was
      // pressed, just bail.
      if (savedIndex === null || !evt.shiftKey) return;

      // Shift-clicked the same message :-/
      if (index === savedIndex) return;

      // Get the subset of the message list between the
      // two indicies.
      console.time("toggle range")

      // subset becomes ['abc','def','ghi','jkl']
      const subset = this.orderedDocsUser.map(({ id }) => id).slice(
          Math.min(index, savedIndex),
          Math.max(index, savedIndex) + 1
      );

      // Determine the operation based on the checked state
      // of the clicked checkbox.
      const toggleFn = evt.currentTarget.checked ? addCheckedSubset : removeCheckedSubset ;

      this.selectedItems = toggleFn(this.selectedItems, subset);
      console.timeEnd("toggle range")

    },
    getMyDocs: function (){
      if (!this.myDocs){
        this.myDocs = !this.myDocs;
        console.log("entra");

        this.$store.dispatch ("isLoadingOn");

        this.$axios.post ("/client_documents_folders",{
          breadcrumbs: this.breadcrumbs
        })
            .then ((response) => {
              console.log(response.data);
              this.documentsUser = response.data;
              this.item = [];
              this.fileView = 1;
              this.$store.dispatch ('isLoadingOff');
              this.onLoadBreadcrumb ();
              this.$store.dispatch ("isLoadingOff");
              this.LoadDataTable();
              if(this.myDocs){
                //this.dataTable.DataTable().clear().destroy();
                console.log("entra");
              }
            })
            .catch(() => {
              this.$store.dispatch ("isLoadingOff");
            });
      }
    },
    createFolderCode: function (){
      console.log("createFolderCode");
      //document.getElementById("folder_code").innerHTML="hola";
      return "";
    },
    template: function () {
      return `<div class="dz-preview dz-file-preview">
                <div class="dz-image">
                    <div data-dz-thumbnail-bg></div>
                </div>
                <div class="dz-details">
                    <div class="dz-size"><span data-dz-size></span></div>
                    <div class="dz-filename"><span data-dz-name></span></div>
                </div>
                <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                <div class="dz-error-message"><span data-dz-errormessage></span></div>
                <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                <div class="dz-error-mark"><i class="fa fa-close"></i></div>
            </div>
        `;
    },
    thumbnail: function(file, dataUrl) {
      var j, len, ref, thumbnailElement;
      if (file.previewElement) {
        file.previewElement.classList.remove("dz-file-preview");
        ref = file.previewElement.querySelectorAll("[data-dz-thumbnail-bg]");
        for (j = 0, len = ref.length; j < len; j++) {
          thumbnailElement = ref[j];
          thumbnailElement.alt = file.name;
          thumbnailElement.style.backgroundImage = 'url("' + dataUrl + '")';
        }
        return "dsf"
      }
    },
    startEditing(index) {
      this.editOffset = index
      this.editPost = this.request_items[index]
      this.editPostOri = JSON.parse(JSON.stringify(this.editPost))
      // set focus ke element input
      this.$nextTick(function(){
        console.log('item-user-'+this.editOffset)
        document.getElementById('item-user-'+this.editOffset).focus()
      }.bind(this))
    },
    updatePost() {
      let data = {
        name            : this.editPost.name,
      };

      this.$axios.put("/folder_documentation/"+this.editPostOri.id, data)
          .then((response) => {
            console.log(response.data);
            //this.$store.dispatch('isLoadingOff');
          })
          .catch(() => {
            //this.$store.dispatch('isLoadingOff');
          });
      this.editOffset = -1
      this.editPostOri = {}
      this.editPost = {}
    },
    cancelEditing() {
      this.$set(this.request_items, this.editOffset, this.editPostOri)
      this.editOffset = -1
      this.editPostOri = {}
      this.editPost = {}
    },
    copyLinkPath() {
      let testingCodeToCopy = document.querySelector('#path-code')
      console.log(testingCodeToCopy.value)
      testingCodeToCopy.setAttribute('type', 'text')
      testingCodeToCopy.select()

      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'correctamente' : 'erroneamente';
        var path ="https://cleverdocs.cleverbsolutions.com/storage/app/"+ testingCodeToCopy.value;
        alert(path+' ha sido copiado ' + msg);
      } catch (err) {
        alert('Oops, imposible de copiar');
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    unSelectTheader(){
      this.hoverTheader = false
    },
    selectTheader(){
      this.hoverTheader = true
    },
    selectItem (item) {
      //this.selectedItem = item
      this.hoverItem = item;
    },
    unSelectItem () {
      //this.selectedItem = false
      this.hoverItem = false
    },
    formatDate2: function(dt){

      return dt != null ? moment(dt, 'DD/MM/YY HH:mm:ss').format('DD-MM-YYYY HH:mm:ss') : null;

    },
    formatDate: function(dt){

      return dt != null ? moment(dt, 'DD/MM/YY HH:mm:ss').format('DD/MM/YYYY') : null;

    },
    sendingEvent (file, xhr, formData)
    {
      console.log("sendingEvent");
      formData.append ('parent_id', this.selectFolder);
      formData.append ('user_id', this.user.id);
      formData.append ('folder_code', this.onPrintBreadcrumb());
      console.log(this.onPrintBreadcrumb());
      //this.$refs["dropzone"].removeFile(file);
      var ext = file.name.split('.').pop();
      console.log(ext);
      /*switch(ext){
        case 'pdf':$(file.previewElement).find(".dz-image img").attr("src", "https://modernb.akamai.odsp.cdn.office.net/files/fabric-cdn-prod_20211207.001/assets/item-types/20/pdf.svg"); break;
        case 'doc':$(file.previewElement).find(".dz-image img").attr("src", "https://modernb.akamai.odsp.cdn.office.net/files/fabric-cdn-prod_20211207.001/assets/item-types/20/pdf.svg"); break;
        case 'docx':$(file.previewElement).find(".dz-image img").attr("src", "https://modernb.akamai.odsp.cdn.office.net/files/fabric-cdn-prod_20211207.001/assets/item-types/20/pdf.svg"); break;
        case 'xls':$(file.previewElement).find(".dz-image img").attr("src", "https://modernb.akamai.odsp.cdn.office.net/files/fabric-cdn-prod_20211207.001/assets/item-types/20/pdf.svg"); break;
        case 'pdf':$(file.previewElement).find(".dz-image img").attr("src", "https://modernb.akamai.odsp.cdn.office.net/files/fabric-cdn-prod_20211207.001/assets/item-types/20/pdf.svg"); break;
      }*/

      if (ext == "pdf") {
        $(file.previewElement).find(".dz-image img").attr("src", "https://modernb.akamai.odsp.cdn.office.net/files/fabric-cdn-prod_20211207.001/assets/item-types/20/pdf.svg");
      } else if (ext.indexOf("doc") != -1 || ext.indexOf("docx") != -1) {
        $(file.previewElement).find(".dz-image img").attr("src", "https://modernb.akamai.odsp.cdn.office.net/files/fabric-cdn-prod_20211207.001/assets/item-types/20/docx.svg");
      } else if (ext.indexOf("xls") != -1 || ext.indexOf("xlsx") != -1) {
        $(file.previewElement).find(".dz-image img").attr("src", "https://modernb.akamai.odsp.cdn.office.net/files/fabric-cdn-prod_20211207.001/assets/item-types/20/xlsx.svg");
      }

    },
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    DestroyDatatable(){
      console.log("entra and destroy");
    },
    LoadDataTable ()
    {
      setTimeout (() => {
        this.dataTable = window.$("#clientsDocs").dataTable ({
          //dom: "Bfrtip",
          dom: 'fBrtip<"clear">l',
          retrieve: true,
          buttons: [
            {
              extend: "excelHtml5",
              title: "Documentos",
              text:
                  '<i class="fas fa-file-excel text-success" title="Excel"></i>',
              exportOptions: {
                columns: [2, 3, 4, 5],
              }
            },
            {
              extend: "pdfHtml5",
              text: '<i class="fas fa-file-pdf text-danger" title="PDF"></i>',
              orientation: "landscape",
              title: "Documentos",
              exportOptions: {
                columns: [ 2, 3, 4, 5],
              },
              customize: function (doc)
              {
                doc.content [1].table.widths = "*";
                doc.styles.tableHeader.alignment = "center";
              }
            },
            {
              extend:    'copyHtml5',
              text:      '<i class="fa fa-clipboard"></i>',
              title:'Documentos',
              titleAttr: 'Copiar',
              className: 'btn btn-app export barras',
            },
            {
              extend: "print",
              title: "Documentos",
              text: '<i class="fas fa-print" title="Imprimir"></i>',
              exportOptions: {
                columns: [ 2, 3, 4, 5],
              }
            }
          ],
          autoWidth: false,
          pagingType: "full_numbers",
          pageLength: 25,
          language:
              {
                url: "//cdn.datatables.net/plug-ins/1.10.21/i18n/Spanish.json",
              }
        });
      }, 100);
    },
    onSelectAll ()
    {
      this.item = [];
      if (this.myDocs){
        this.documentsUser.forEach ((item) => {
          this.item.push (item.id)
        })
      }else{
        this.documents.forEach ((item) => {
          this.item.push (item.id)
        })
      }
      /*this.documents.forEach ((item) => {
        if (item.document_type_id != 1) this.item.push (item.id)
      })*/
    },
    onUnSelectAll(){
      this.item = [];
      this.selected = [];
      this.fileView = 1;
    },
    fileComplete(){
      console.log("fileComplete");
      //this.$refs["dropzone"].removeFile(file);
    },
    cancelFile(){
      console.log("cancelFile");
    },
    toggleFolderTree(){

      //setTimeout (() => {
        //this.users_folder =[];
        this.checkedUsersId = [];
        for (let key in this.users_folder) {
          //console.log(this.users_folder[key].id);
          let data ={
              user_id : this.users_folder[key].id,
              folder_id: this.itemSelected.id ? this.itemSelected.id : '',
          };
          this.checkedUsersId = [];
          this.$axios.post ("document/folder_user_notify",data)
              .then ((response) => {
                //console.log(response.data[0]);
                this.checkedUsersId.push(response.data[0].user_id);
              })
              .catch (() => {
                this.$store.dispatch ('isLoadingOff');
              });
        }

      console.log("toggleFolderTree");
      this.showFolderTree = !this.showFolderTree;
      //}, 100);

    },
    uploadFileSuccess(file, response){
      console.log("uploadFileSuccess");
      console.log(response);
      this.onUpdateParentFiles(this.selectFolder, false);
      this.$refs["dropzone"].removeFile(file);
      this.onRefresh();
    },
    UploadSuccess(){
      console.log("UploadSuccess");
      this.onRefresh();
      //this.$refs["dropzone"].removeAllFiles();
      //this.onSaveFolder();
      this.$dialog.alert({
        //title: this.$t("add_file"),
        body: this.$t("add_file_text"),
      })
    },
    onUpdateParent (parent){
      console.log(parent);
      console.log("ACTUALIZAMOS PARENT_ID FOLDER");
      return "done it";
    },
    onShowModalShareFolder(event, document){
      this.itemSelected = document;
      this.titleModal = "Enviar vínculo";
      this.files = [];
      this.document_type = null;
      this.showShareModal = true;
    },
    onShowModalFolder ()
    {
      //this.$refs.search.focus();
      this.document_type = 1
      this.titleModal = this.$t("add_folder");
      this.showModal = true;
      this.name = null;
      this.template_id = null,
          this.folder_code = this.itemSelected ? this.itemSelected.folder_code : null;
      this.request_items = [];
      this.checkedUsersId = [];
      this.id = null;
      this.changeTemplate = false;

      setTimeout(function () {
        document.getElementById('folderName').focus()
      }, 300)
    },
    toggleList(){
      //console.log(this);
      this.isToggled = false;
    },
    toggleMosaic(){
      //console.log(this);
      this.isToggled = true;
    },
    onShowModalFile(){
      this.titleModal = this.$t("add_file");
      this.files = [];
      this.document_type = null;
      this.showModal = true;
    },
    updateDocuments (data)
    {
      this.documents = data;
    },
    toggleActiveCheckBox(document){

      console.log(document);

      let data = {
        active            : !document.active,
      };

      this.$axios.put("/documents/"+document.id, data)
          .then((response) => {
            console.log(response.data);
            //this.$store.dispatch('isLoadingOff');
          })
          .catch(() => {
            //this.$store.dispatch('isLoadingOff');
          });

    },
    onDownloadFile ()
    {
      let doc_id = this.getDocument(this.item).id;
      console.log((this.getDocument(this.item).id));
      this.$store.dispatch ('isLoadingOn');
      this.$axios ({
        url: '/document/download_file/'+doc_id, //your url
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => {
        //console.log(response.data);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        let fileName = response.headers["content-disposition"].split(
            "filename="
        )[1];
        let result = fileName.replace(/"/g, "");

        link.setAttribute('download', result); //or any other extension
        document.body.appendChild(link);
        link.click();
        this.$store.dispatch ('isLoadingOff');
      });
    },
    onDeleteAllFile()
    {
      console.log(this.item);
      this.item.forEach ((item) => {
        let doc = this.getDocument(item);
        console.log(doc);
        if (doc.active == 0){
          console.log("active");
          this.$axios.post (`/delete_documents`, {"documents_id" : item, "doc_url": (doc.url)})
              .then (() => {
                this.itemSelected = null;
                this.onUpdateParentFiles(doc.parent_id, true);
                this.item = [];
                this.onRefresh ();
                this.onLoadFolders ();
                this.$store.dispatch ('isLoadingOff');
              })
              .catch (() => {
                this.$store.dispatch ('isLoadingOff');
              });
        }
      });
    },
    onDeleteFolderFile(data)
    {
      console.log(data);
      data.forEach ((item) => {
        console.log(item["document_type_id"]);
        if (item["num_files"] == 0){
          this.$store.dispatch ('isLoadingOn');
          this.$axios.post (`/delete_documents`, {"documents_id" : item["id"], "doc_url": item["url"]})
              .then (() => {
                this.itemSelected = null;
                this.onUpdateParentFiles(item["parent_id"], true);
                this.item = [],
                    this.onRefresh ();
                this.onLoadFolders ();
                this.$store.dispatch ('isLoadingOff');
              })
              .catch (() => {
                this.$store.dispatch ('isLoadingOff');
              });
        }else{
          this.$axios (`/documents?where-parent_id=${item["id"]}`)
              .then ((response) => {
                this.onDeleteFolderFile(response.data);
                /*this.documents = response.data;
                this.item = [];
                this.fileView = 1;
                this.$store.dispatch ('isLoadingOff');
                this.onLoadBreadcrumb ();*/
              })
              .catch (() => {
                this.$store.dispatch ('isLoadingOff');
              });
        }
      });
    },
    onDeleteFile ()
    {
      if (this.getDocument(this.item).active == 1)
      {
        this.$dialog.alert ({
          //title: this.$t("warning_not_active"),
          body: this.$t("warning_not_activeTextError"),
        })
        return false;
      }

      //console.log((this.getDocument(this.item).url).replace('CleverDocs',''));
      let doc = this.getDocument(this.item);
      console.log(doc.num_files);
      if (doc.num_files == 0){
        this.$store.dispatch ('isLoadingOn');
        this.$axios.post (`/delete_documents`, {"documents_id" : this.item, "doc_url": (doc.url)})
            .then (() => {
              this.itemSelected = null;
              this.onUpdateParentFiles(doc.parent_id, true);
              this.item = [],
                  this.onRefresh ();
              //this.onLoadFolders ();
              this.$store.dispatch ('isLoadingOff');
            })
            .catch (() => {
              this.$store.dispatch ('isLoadingOff');
            });
      }else{
        this.$axios (`/documents?where-parent_id=${doc.id}`)
            .then ((response) => {
              this.onDeleteFolderFile(response.data);
              /*this.documents = response.data;
              this.item = [];
              this.fileView = 1;
              this.$store.dispatch ('isLoadingOff');
              this.onLoadBreadcrumb ();*/
            })
            .catch (() => {
              this.$store.dispatch ('isLoadingOff');
            });
      }
      /**/
    },
    onAddRequest ()
    {
      if (this.item_request)
      {
        this.request_items.push ({
          name : this.item_request,
          isNew : true,
          isIndex : false
        });
        this.item_request = null;
      }
    },
    onDropDown(event, document){
      //console.log(document);
      //console.log(this.itemSelected);
      //console.log(document);
      if (event){

        //this.onLoadRequestDocumentation (document.id);
        this.itemCheckItemSelected = document;
        this.itemSelected = document;
        this.item = [];
        //console.log(this.itemSelected);
        if (!this.selected.includes(document.id)) {
          if (this.item.includes(document.id)) {
            //this.item.splice(this.item.findIndex(v => v === document.id), 1);
          } else {
            this.item.push(document.id);
            this.selected.push(document.id);
          }
        }
      }
    },

    onEditDocumentationDrop ()
    {
      if (this.itemSelected){
        this.document_type = 1;
        this.titleModal = this.$t("edit_req_doc")+" para "+this.itemSelected.name;
        this.name = this.itemSelected.name;
        this.id = this.itemSelected.id;
        this.folder_code = this.itemSelected.folder_code;
        this.selectEditDocFolder = this.itemSelected.parent_id;
        this.template_id = null,
            this.request_items = _.sortBy(this.itemSelected.request_documentation, 'position_list');
        /*this.template_id = null,
            this.request_items = this.itemDocRequired.request_documentation;*/
        this.showModalRequiredDoc = true;
        this.changeTemplate = false;
      }
    },
    onEditDocumentation ()
    {
      console.log(this.itemSelected);
       if (this.itemDocRequired){
        this.document_type = 1;
        this.titleModal = this.$t("edit_req_doc")+" para "+this.itemDocRequired.name;
        this.name = this.itemDocRequired.name;
        this.id = this.itemDocRequired.id;
        this.folder_code = this.itemDocRequired.folder_code;
        this.selectEditDocFolder = this.itemDocRequired.parent_id;
         this.template_id = null,
             this.request_items = _.sortBy(this.itemDocRequired.request_documentation, 'position_list');
        /*this.template_id = null,
            this.request_items = this.itemDocRequired.request_documentation;*/
        this.showModalRequiredDoc = true;
        this.changeTemplate = false;
      }
      /*this.document_type = 1;
      this.titleModal = this.$t("edit_req_doc")+" para "+this.itemSelected.name;
      this.name = this.itemSelected.name;
      this.id = this.itemSelected.id;
      this.folder_code = this.itemSelected.folder_code;
      this.template_id = null,
          this.request_items = this.itemSelected.request_documentation;
      this.showModalRequiredDoc = true;
      this.changeTemplate = false;*/
    },
    onEditFolder ()
    {
      this.document_type = 1;
      this.titleModal = this.$t("edit_folder");
      this.name = this.itemSelected.name;
      this.id = this.itemSelected.id;
      this.folder_code = this.itemSelected.folder_code;
      this.template_id = null,
          this.request_items = _.sortBy(this.itemSelected.request_documentation, 'position_list');
      /*this.template_id = null,
          this.request_items = this.itemSelected.request_documentation;*/
      this.showModal = true;
      this.changeTemplate = false;
    },
    onGetNumberDocs (id)
    {
      let me = this;
      //console.log(this.isToggled);
      this.$axios (`/documents?where-parent_id=${id}`)
          .then ((response) => {
            this.$store.dispatch ('isLoadingOff');
            //const count = count(response.data);
            //console.log(response.data.length);
            me.count = response.data.length;

            if(this.isToggled)
            {
              var badgediv = document.getElementById("badge_"+id);
              badgediv.innerHTML=response.data.length;
              if (response.data.length == 0){
                //console.log("hidding mosaic badges");
                badgediv.style.display = 'none';
              }
            }else{
              var badgediv2 = document.getElementById("badge_list_"+id);
              badgediv2.innerHTML=response.data.length;
              if (response.data.length == 0){
                //console.log("hidding list badges");
                badgediv2.style.display = 'none';
              }
            }

          })
          .catch (() => {
            this.$store.dispatch ('isLoadingOff');
          });

    },
    onSelectPathFolder (document)
  {
    console.log(document.id);
    console.log(document.parent_id);
      if (this.selectFolder != document.id)
      {
        console.log(this.selectFolder);
        this.itemDocRequired = document;
        this.itemSelected = document;
        this.onLoadRequestDocumentation (document.parent_id);
        this.sfolder = document;
        this.$store.dispatch ('isLoadingOn');
        this.$axios (`/documents?where-parent_id=${document.parent_id}`)
            .then ((response) => {
              this.$store.dispatch ('isLoadingOff');
              this.documents = response.data;
              this.item = [];
              this.documentResp = this.documents;
              this.selectFolder = document.parent_id;
              this.fileView = 1;
              this.onLoadBreadcrumb ();
              this.showOptions = false;
            })
            .catch (() => {
              this.$store.dispatch ('isLoadingOff');
            });
      }
      else this.onRefresh ();
      if (this.myDocs) this.getMyDocs();
    },
    onSelectFolder (document)
    {
      if (this.selectFolder != document.id)
      {
        this.itemDocRequired = document;
        this.itemSelected = document;
        this.onLoadRequestDocumentation (document.id);
        this.sfolder = document;
        this.$store.dispatch ('isLoadingOn');
        this.$axios (`/documents?where-parent_id=${document.id}`)
            .then ((response) => {
              this.$store.dispatch ('isLoadingOff');
              this.documents = response.data;
              this.item = [];
              this.documentResp = this.documents;
              this.selectFolder = document.id;
              this.fileView = 1;
              this.onLoadBreadcrumb ();
              this.showOptions = false;
            })
            .catch (() => {
              this.$store.dispatch ('isLoadingOff');
            });
      }
      else this.onRefresh ();
      if (this.myDocs) this.getMyDocs();
    },
    onSelectTemplate ()
    {
      this.changeTemplate = true;
      this.$store.dispatch ('isLoadingOn');
      this.$axios ("/template_request?where-template_id=" + this.template_id)
          .then ((response) => {
            let data =  response.data;
            data.forEach ((item) => {
              item.isNew = true;
            });
            this.request_items = data;
            this.$store.dispatch ('isLoadingOff');
          })
          .catch (() => {
            this.$store.dispatch ('isLoadingOff');
          })
    },
    onRemoveRequestFolder ()
    {
      this.$axios.delete ("/folder_request/" + this.id)
          .then (() => {

          })
    },
    deleteEvent (item, index)
    {
      this.request_items.splice (index, 1);
      if (!item.isNew)
      {
        this.$store.dispatch ('isLoadingOn');
        this.$axios
            .delete ("/folder_documentation/" + item.id)
            .then (() => {
              this.$store.dispatch ('isLoadingOff');
            })
      }
    },
    onSelectItemRequest (item)
    {
      this.documents = [];
      for (let row in item.request_doc)
      {
        this.documentResp.forEach ((document) => {
          if (document.id == item.request_doc [row].document_id) this.documents.push (document);
        })
      }
      this.itemRequestSelected = item;
    },
    onSelectRequest (item)
    {
      let self = this;
      if (this.item.length == 0)
      {
        this.$dialog.alert ({
          //title: this.$t("CargarDocumentacion"),
          body: this.$t("CargarDocumentacionTextError"),
        })
        return false;
      }
      if (this.getDocument(this.item).active == 1)
      {
        this.$dialog.alert ({
          //title: this.$t("warning_not_active"),
          body: this.$t("warning_not_activeTextError"),
        })
        return false;
      }
      let data = {
        "documents_id" : this.item,
        "request_type_id" : item.id
      };
      this.$dialog.confirm ({
        //title: self.$t("CargarDocumentacion"),
        body: self.$t("CargarDocumentacionText"),
        okText: self.$t("Sí"),
        cancelText: self.$t("No"),
      })
          .then (
              function ()
              {
                self.$store.dispatch ('isLoadingOn');
                self.$axios
                    .post ("/document_request", data)
                    .then (() => {
                      self.item = [];
                      self.onLoadRequestDocumentation (self.selectFolder);
                      self.$store.dispatch ('isLoadingOff');
                    })
                    .catch (() => {
                      self.$store.dispatch ('isLoadingOff');
                    })
              }
          )
    },
    onRemoveRequest (item)
    {
      let self = this;
      this.$dialog
          .confirm ({
            backdropClose: false,
            //title: this.$t("CargarDocumentacion"),
            body: this.$t("UncheckItemDocumentation"),
          })
          .then (() => {
            self.$axios.delete ("/document_request/" + item.id)
                .then (() => {
                  self.onLoadRequestDocumentation (self.selectFolder);
                })
          })
    },
    onLoadRequestDocumentation (id)
    {
      this.$axios ("/folder_documentation?where-folder_id=" + id)
          .then ((response) => {
            //this.request_documentation = response.data;
            this.request_documentation = _.sortBy(response.data, 'position_list');
            let self = this;
            this.request_documentation.forEach ((item) => {
              if (item.request_doc.length > 0) self.request_id.push (item.request_doc [0].request_id);
            });
            if (this.itemRequestSelected) self.onSelectItemRequest (this.itemRequestSelected);
          })
    },
    onOpenDocument (id)
    {
      this.$store.dispatch ('isLoadingOn');
      this.$axios (`/document/download/${id}`)
          .then ((response) => {
            this.$store.dispatch ('isLoadingOff');
            let file = response.data;
            if (file.type == "BASE64")
            {
              var byteCharacters = atob (file.url);
              var byteNumbers = new Array (byteCharacters.length);
              for (var i = 0; i < byteCharacters.length; i++)
              {
                byteNumbers[i] = byteCharacters.charCodeAt (i);
              }
              var byteArray = new Uint8Array (byteNumbers);
              var file64 = new Blob (
                  [byteArray], {type: 'application/pdf;base64'}
              );
              var fileURL = URL.createObjectURL (file64);
              window.open (fileURL);
            }
            else window.open (file.url);
          })
          .catch (() => {
            this.$store.dispatch ('isLoadingOff');
          })
    },
    onCheckItem (event, document)
    {
      if (event.target.checked) this.itemCheckItemSelected = document;
      else this.itemCheckItemSelected = this.item.length == 1 ? this.getDocument (this.item [0]) : null;
      if (this.item.length == 0) this.fileView = 1;
      //console.log(this.item.length);
      //console.log(this.item);
      if (event.target.checked) this.itemSelected = document;
      else this.itemSelected = this.item.length == 1 ? this.getDocument (this.item [0]) : null;
      if (this.item.length == 0) this.fileView = 1;
    },
    getUserName (id)
    {
      //console.log(this.getDocument(id).user_id);
      //console.log(this.folders);
      return this.getDocument(id).user_id;
    },
    getDocument (id)
    {
      for (let row in this.documents)
      {
        if (this.documents [row].id == id) return this.documents [row];
      }
      return null;
    },
    onSearchFilter ()
    {
      console.log(this.selectFolder);
      this.$store.dispatch ('isLoadingOn');
      let endpoint;
      /*if (this.isAdmin) endpoint = "/search_documents";
      else endpoint = "/client/documents";*/
      endpoint = "/search_documents";

      let parentFilter = "";
      //if (this.selectFolder != 0) parentFilter = "&where-parent_id="+this.selectFolder;
      parentFilter = "&where-parent_id="+this.selectFolder;

      this.item = [];
      this.fileView = this.request_documentation.length > 0 ? 2 : 1;
      let filter = "";

      if (this.filter != "") filter = "?search="+this.filter;

      if (this.myDocs){
        endpoint = "/search_documents_user"
      }

      this.$axios (endpoint + filter + parentFilter)
          .then ((response) => {
            if (this.myDocs){
              this.documentsUser = response.data
            }else{
              this.documents = response.data
            }
            this.$store.dispatch ('isLoadingOff');
          })
          .catch (() => {
            this.$store.dispatch ('isLoadingOff');
          });
    },
    onSaveEditFolder()
    {
      this.$v.$touch ();
      if (!this.$v.$invalid)
      {
        this.$store.dispatch ('isLoadingOn');
        let data;
        if (this.isAdmin)
        {
          let newFolders = this.request_items.filter ((item) => {
            return item.isNew;
          });
          if (this.id && this.changeTemplate) this.onRemoveRequestFolder ();
          data = {
            name              : this.name,
            parent_id         : this.selectEditDocFolder,
            user_id           : this.user.id,
            active            : 0,
            document_type_id  : this.document_type,
            folder_code       : this.folder_code,
            request_folder    : newFolders
          };
        }
        else
        {
          data = {
            name              : this.name,
            parent_id         : this.selectEditDocFolder,
            user_id           : this.user.id,
            active            : 0,
            document_type_id  : this.document_type
          };
        }
        console.log(data);
        console.log(this.id);
        let request;
        if (this.id) request = this.$axios.put ("/documents/" + this.id, data);
        else request = this.$axios.post ("/documents", data);
        request
            .then (() => {
              this.showModal = false;
              this.showModalRequiredDoc = false;
              this.name = null;
              this.folder_code = null;
              this.folder = {};
              this.$v.$reset ();
              this.onLoadRequestDocumentation (this.id);
              this.onRefresh ();
              this.onLoadFolders ();
              //this.onLoadFolders ();
              this.$store.dispatch ('isLoadingOff');
            })
            .catch (() => {
              this.$store.dispatch ('isLoadingOff');
            });
      }
    },
    onSaveFolder ()
    {
      this.$v.$touch ();
      if (!this.$v.$invalid)
      {
        this.$store.dispatch ('isLoadingOn');
        let data;
        if (this.isAdmin)
        {
          let newFolders = this.request_items.filter ((item) => {
            return item.isNew;
          });
          if (this.id && this.changeTemplate) this.onRemoveRequestFolder ();
          data = {
            name              : this.name,
            active            : this.active,
            parent_id         : this.selectFolder,
            user_id           : this.user.id,
            document_type_id  : this.document_type,
            folder_code       : this.onPrintBreadcrumb(),
            request_folder    : newFolders
          };
        }
        else
        {
          data = {
            name              : this.name,
            active            : this.active,
            parent_id         : this.selectFolder,
            user_id           : this.user.id,
            document_type_id  : this.document_type
          };
        }
        console.log(this.id);
        console.log(data);

        let request;
        if (this.id) request = this.$axios.put ("/documents/" + this.id, data);
        else request = this.$axios.post ("/documents", data);
        request
            .then (() => {
              this.showModal = false;
              this.showModalRequiredDoc = false;
              this.name = null;
              this.folder_code = null;
              this.folder = {};
              this.$v.$reset ();
              this.onRefresh ();
              this.onLoadFolders ();
              this.checkedUsersId = [];
              this.showFolderTree = false;
              this.$store.dispatch ('isLoadingOff');
            })
            .catch (() => {
              this.$store.dispatch ('isLoadingOff');
            });
      }
    },
    onUpdateParentFiles(document_id , decrease){
      //document.active = this.$refs.activeSelected.checked;
      //this.$refs.activeSelected.checked ?  console.log('isActivated') :  console.log('isNotActivated');
      console.log(document_id);
      if(document_id !=0){

        this.$axios("/documents/"+document_id, )
            .then((response) => {
              //console.log(response.data);
              let data_res = response.data;
              //this.$store.dispatch('isLoadingOff');
              let data = {}
              if (decrease){
                data = {
                  user_id                : this.user.id,
                  num_files              : data_res.num_files>0 ? data_res.num_files-1 : 0
                };
              }else{
                data = {
                  user_id                : this.user.id,
                  num_files              : data_res.num_files+1
                };
              }
              this.$axios.put("/documents/"+document_id, data)
                  .then((response) => {
                    console.log(response.data);
                  })
                  .catch(() => {
                    //this.$store.dispatch('isLoadingOff');
                  });

              if (data_res.parent_id != 0){
                console.log(data_res.parent_id);
                this.onUpdateParentFiles(data_res.parent_id, decrease);
              }
            })
            .catch(() => {
              //this.$store.dispatch('isLoadingOff');
            });
      }
      //let doc = this.getDocument(document_id);

    },
    onSaveFolder2 ()
    {
      console.log(this.selectEditDocFolder);
      this.$v.$touch ();
      if (!this.$v.$invalid)
      {
        this.$store.dispatch ('isLoadingOn');
        let data;
        if (this.isAdmin)
        {
          let newFolders = this.request_items.filter ((item) => {
            return item.isNew;
          });
          console.log(newFolders);
          if (this.id && this.changeTemplate) this.onRemoveRequestFolder ();
          data = {
            name              : this.name,
            active            : 0,
            parent_id         : this.selectEditDocFolder,
            user_id           : this.user.id,
            document_type_id  : this.document_type,
            folder_code       : this.folder_code,
            request_folder    : newFolders
          };
        }
        else
        {
          console.log("aqui?");
          data = {
            name              : this.name,
            active            : 0,
            parent_id         : this.selectEditDocFolder,
            user_id           : this.user.id,
            document_type_id  : this.document_type
          };
        }
        console.log(data);
        console.log(this.id);
        let request;
        if (this.id) request = this.$axios.put ("/documents/" + this.id, data);
        else request = this.$axios.post ("/documents", data);
        request
            .then (() => {
              this.showModal = false;
              this.showModalRequiredDoc = false;
              this.name = null;
              this.folder_code = null;
              this.folder = {};
              this.$v.$reset ();
              this.onRefresh ();
              this.onLoadFolders ();
              //this.onLoadFolders ();
              this.$store.dispatch ('isLoadingOff');
            })
            .catch (() => {
              this.$store.dispatch ('isLoadingOff');
            });
      }
    },
    onUploadDocument ()
    {
      this.error = false;
      if (this.files.length < 1)
      {
        this.error = true;
        return false;
      }
      this.progress = 0;
      this.showProgress = true;
      let progress = 100 / this.files.length;
      const promises = [];
      for (let row in this.files)
      {
        const formData = new FormData ();
        formData.append ("parent_id", this.selectFolder);
        formData.append ("name", this.files [row].name);
        formData.append ("user_id", this.user.id);
        //formData.append ("active", this.files [row].active);
        formData.append ("folder_code", this.onPrintBreadcrumb());
        formData.append ("active", 0);
        formData.append ("document_type_id", this.getFileType (this.files [row].type));
        formData.append ("file", this.files [row]);
        promises.push (new Promise ((resolve) => {
          this.$axios
              .post ("/documents/upload", formData, {headers: {'Content-Type': 'multipart/form-data'}})
              .then (() => {
                this.progress = this.progress + progress;
                resolve ();
                this.onUpdateParentFiles(this.selectFolder, false);
              })
              .catch (() => {
                resolve();
              });
        }));
      }
      Promise
          .all (promises)
          .then (() => {
            this.showModal = false;
            this.files = [];
            this.onRefresh ();
            let self = this;
            setTimeout (() => {
              self.showProgress = false;
            }, 500)
          })
          .catch (() => {
            this.showProgress = false;
          });
    },
    _onFileUpload (event)
    {
      let files = event.target.files;
      if (files.length == 0)
      {
        this.error = true;
        return false;
      }
      for (let row in files)
      {
        if (typeof files [row] == "object") this.files.push (files [row]);
      }
    },
    _onRemoveFile (position)
    {
      this.files.splice (position, 1);
    },
    getFileType (file_type)
    {
      return this.fileTypes [file_type];
    },
    onRefresh ()
    {
      this.$store.dispatch ('isLoadingOn');
      this.$axios (`/documents?where-parent_id=${this.selectFolder}`)
          .then ((response) => {
            this.documents = response.data;
            this.item = [];
            this.fileView = 1;
            this.$store.dispatch ('isLoadingOff');
            this.onLoadBreadcrumb ();
          })
          .catch (() => {
            this.$store.dispatch ('isLoadingOff');
          });
    },
    onSeeBreadcrumbs(){
      this.onOff = !this.onOff
    },
    onPrintBreadcrumb (){
      let str="";
      this.breadcrumbs.forEach ((bread) => {
        str = str+' / '+bread.name;
      });
      return str;
    },
    onLoadBreadcrumb ()
    {
      this.$axios ("/breadcrumb/" + this.selectFolder)
          .then ((response) => {
            this.breadcrumbs = response.data.breadcrumb;
          })
          .catch (() => {
            this.breadcrumbs = [];
          });
    },
    onPressRoot ()
    {
      //if (this.isAdmin)
      //{
        this.$store.dispatch ('isLoadingOn');
        this.$axios (`/${this.root}`)
            .then ((response) => {
              this.documents = response.data;
              this.item = [];
              this.breadcrumbs = [];
              this.selectFolder = 0;
              this.fileView = 1;
              this.request_documentation = [];
              this.itemSelected = null;
              this.$store.dispatch ('isLoadingOff');
            })
            .catch (() => {
              this.$store.dispatch ('isLoadingOff');
            });
      //}
    },
    onShowComments(){
      this.onLoadComments();
      this.showModalComments = true;
      this.onReadComments();
    },
    onCloseModal(){
      this.showModalComments = false;
      this.comments       = [];
      this.comment_text   = null
      this.error_comment  = false;
    },
    onLoadComments(){
      this.$store.dispatch('isLoadingOn');
      this.$axios("/comments?where-document_id="+this.itemSelected.id)
          .then((response) => {
            this.comments = response.data;
            this.$store.dispatch('isLoadingOff');
          })
          .catch(() => {
            this.$store.dispatch('isLoadingOff');
          });
    },
    onReadComments(){
      if(this.isAdmin){
        this.$axios("/read_comments/"+this.itemSelected.id)
            .then(() => {
            })
      }
    },
    onSaveComment(){
      if(!this.comment_text){
        this.error_comment = true;
        return false;
      }
      this.$store.dispatch('isLoadingOn');
      let data = {
        comment : this.comment_text,
        document_id : this.itemSelected.id,
      };
      this.$axios.post("/comments",data)
          .then(() => {
            this.comment_text = null;
            this.onLoadComments();
            this.error_comment = false;
            this.getEmailsNotifications(2);
            this.$store.dispatch('isLoadingOff');
          })
          .catch(() => {
            this.$store.dispatch('isLoadingOff');
          });
    },
    getEmailsNotifications(noti_type){
      console.log(noti_type);
      console.log(this.itemSelected.parent_id);
      console.log(this.users_folder);
      this.checkedUsersId = [];
      for (let key in this.users_folder) {
        //console.log(this.users_folder[key].id);
        let data ={
          user_id : this.users_folder[key].id,
          folder_id: this.itemSelected.parent_id ? this.itemSelected.parent_id : '',
        };
        //this.checkedUsersId = [];
        this.$axios.post ("document/folder_user_notify",data)
            .then ((response) => {
              console.log(response.data[0].user_id);
              console.log(this.users_folder[key].email);
              this.checkedUsersId.push(response.data[0].user_id);
              if(response.data[0].user_id != undefined){
                let data ={
                  user: this.users_folder[key],
                  itemSelected: this.itemSelected,
                  notify : noti_type,
                };
                this.$axios.post ("document/email_notify",data)
                    .then ((response) => {
                      console.log(response.data);
                    })
                    .catch (() => {
                      this.$store.dispatch ('isLoadingOff');
                    });
              }
            })
            .catch (() => {
              this.$store.dispatch ('isLoadingOff');
            });
      }
    },
    getInitials(name){
      let string = name.split(" ");
      return string.length > 1 ? string[0].charAt()+string[1].charAt() : name[0]+name[1];
    },
    onLoadDocumentStatus(){
      this.$axios("/conf/document_status")
          .then((response) =>{
            this.document_status = response.data;
          })
    },
    onShowProperties(){
      this.showProperties = true;
    },
    log(event) {
      console.log(event)
    },
    onDownloadAll(){
      let formData = new FormData();
      console.log(this.selected.length);
      console.log(this.item.length);

      formData.append('selected_data', this.selected);
      formData.append('item_data', this.item);
      this.item.forEach((f,x) => {
        formData.append('item'+(x+1), f);
        console.log(this.getDocument(f).id);
        console.log(formData);

        this.$store.dispatch ('isLoadingOn');
        //this.onOpenDocument(this.getDocument(f).id);
        this.$axios ({
            url: '/document/download_file/'+this.getDocument(f).id, //your url
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {
            //console.log(response.data);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            let fileName = response.headers["content-disposition"].split(
                "filename="
            )[1];
            let result = fileName.replace(/"/g, "");

            link.setAttribute('download', result); //or any other extension
            document.body.appendChild(link);
            link.click();
            //window.URL.revokeObjectURL(blob);
            this.$store.dispatch ('isLoadingOff');
          });
      });
    },
    onDownloadZip(){
      console.log("zipping");
      let formData = new FormData();
      this.$store.dispatch('isLoadingOn');
      //console.log(this.selected.length);
      if(this.item.length == 1 ){
        let doc = this.getDocument(this.item);
        console.log(doc);
        if (doc.document_type_id!=1){
          this.onDownloadAll();
        }else{
          formData.append ('items', this.item);
          formData.append ('clientsDocs', this.myDocs);
          this.$axios .post('/document/zip_and_download',
              formData, {
                responseType: 'blob', // important
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              }).then(response => {
            console.log(response.data);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            link.setAttribute('download', "files.zip"); //or any other extension
            document.body.appendChild(link);
            link.click();
            //window.URL.revokeObjectURL(blob);
            this.$store.dispatch ('isLoadingOff');
          }).catch (() => {
            this.$store.dispatch ('isLoadingOff');
          });
        }
      }else{
        formData.append ('items', this.item);
        this.$axios .post('/document/zip_and_download',
            formData, {
              responseType: 'blob', // important
              headers: {
                "Content-Type": "multipart/form-data"
              }
            }).then(response => {
          console.log(response.data);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;

          link.setAttribute('download', "files.zip"); //or any other extension
          document.body.appendChild(link);
          link.click();
          //window.URL.revokeObjectURL(blob);
          this.$store.dispatch ('isLoadingOff');
        }).catch (() => {
          this.$store.dispatch ('isLoadingOff');
        });
      }
    },
    onLoadFolders(){
      if(this.isAdmin){
        this.$axios("documents?where-document_type_id=1")
            .then((response)=>{
              let data = response.data;
              this.getParents(data)
            })
      }
      else{
        this.$axios("/client/folders")
            .then((response)=>{
              let data = response.data;
              this.getParents(data)
            })
      }
    },
    getParents(data){
      let keys = [];
      for(let row in data){
        if(!keys.includes(data[row].parent_id))
          keys.push(data[row].parent_id) ;
      }
      data.forEach((item)=>{
        if(keys.includes(item.id))
          item.hasChild = true;
        item.icon = 'fa fa-folder folder-icon';
        if(item.parent_id == 0)
          delete item.parent_id;
        if(!this.isAdmin)
          item.expanded = true;
      });
      if(this.show)
        this.$refs.treeview.ej2Instances.fields.dataSource = data;
      else
        this.fields.dataSource = data;
      this.directory = data;
      this.show = true;
    },
    onSelectNode (event)
    {
      console.log(event.nodeData);
      this.parent_folder = event.nodeData.parentID;

      if (event.nodeData.id == 0)
      {
        this.$store.dispatch('isLoadingOn');
        this.documents = this.indexFolder;
        this.$store.dispatch('isLoadingOff');
      }
      else
      {
        let data = event.nodeData;
        data.folder_code = this.onGetFolderCode(data.id);
        this.onSelectFolder(data);
      }
    },
    onGetFolderCode (id)
    {
      let Code = "";
      for (let row in this.directory)
      {
        if (this.directory[row].id == id)
        {
          return this.directory[row].folder_code;
        }
      }
      return Code;
    },
    nodeEdited: function(args) {
      this.$store.dispatch ('isLoadingOn');
      let data;
      if (args.newText.trim() == "") {
        args.cancel = true;
      }
      else if (args.newText != args.oldText) {
        data = {
          name              : args.newText,
          active            : 0,
          num_files         : 0,
          parent_id         : args.nodeData['parentID'],
          user_id           : this.user.id,
          document_type_id  : 1
        };
        console.log(this.id);
        console.log(data);

        let request;
        if (this.id) request = this.$axios.put ("/documents/" + this.id, data);
        else request = this.$axios.post ("/documents", data);
        request
            .then ((response) => {
              console.log(this.selected)
              console.log(response.data.id);
              console.log(args.nodeData['id']);

              //document.getElementById(args.nodeData['id']).setAttribute('data-uid', response.data.id)
              this.name = null;
              this.folder_code = null;
              this.folder = {};
              this.onRefresh ();
              //this.onLoadFolders ();
              this.$store.dispatch ('isLoadingOff');
            })
            .catch (() => {
              this.$store.dispatch ('isLoadingOff');
            });
      }
      this.$store.dispatch ('isLoadingOff');
    },
    getFolderNotification:function(e){
      var id = e.target.value;
      var selected = event.target.checked;
      console.log(id);
      console.log(selected);
      console.log(this.itemSelected.id);
      console.log(this.itemSelected.parent_id);
    },
    selectUserCheck:function(e){
      var id = e.target.value;
      var selected = event.target.checked;
      console.log(selected);
      console.log(this.itemSelected.id);
      console.log(this.itemSelected.parent_id);
      let data = {
        user_id: id,
        folder_id: this.itemSelected.id,
        notify : selected ? '1' : '0',
      };
      this.$axios.post("/client/folder_check_user", data)
          .then((response) => {
            console.log(response.data);
            //this.$store.dispatch('isLoadingOff');
          })
          .catch(() => {
            //this.$store.dispatch('isLoadingOff');
          });
    },
    nodeClicked: function(args) {

      /*this.$axios("/document/last_id")
          .then((response) => {
            console.log(response.data);
            //this.$store.dispatch('isLoadingOff');
            this.index = response.data;
          })
          .catch(() => {
            //this.$store.dispatch('isLoadingOff');
          });*/

      console.log(args.event);
      if (args.event.which === 3) {
        var treeObj = document.getElementById('treeview').ej2_instances[0];
        treeObj.selectedNodes = [args.node.getAttribute('data-uid')];
        console.log(treeObj.selectedNodes);
      }
    },
    menuclick: function(args) {
      var treevalidate = document.getElementById('treeview').ej2_instances[0];
      var targetNodeId = treevalidate.selectedNodes[0];
      this.item[0] = targetNodeId;
      if (args.item.text == "Añadir Carpeta") {
        var nodeId = "tree_" + this.index;
        var item = { id: nodeId, name: "Nueva Carpeta" , icon: 'fa fa-folder folder-icon'};
        treevalidate.addNodes([item], targetNodeId, null);
        this.index++;
        treevalidate.fields.dataSource.push(item);
        treevalidate.beginEdit(nodeId);
        this.id = '';
      }
      else if (args.item.text == "Borrar Carpeta") {
        let self = this;
        this.$dialog.confirm('¿Desea borrar esta carpeta?')
            .then(function() {
              console.log('Clicked on proceed');
              self.onDeleteTreeFolder(self.parent_folder, targetNodeId);
              treevalidate.removeNodes([targetNodeId]);
            })
      }
      else if (args.item.text == "Renombrar Carpeta") {
        treevalidate.beginEdit(targetNodeId);
        this.id = targetNodeId;
      }
    },
    onDeleteTreeFolder: function(args, id) {
      this.$axios (`/documents?where-parent_id=${args}`)
          .then ((response) => {
            this.$store.dispatch ('isLoadingOff');
            this.documents = response.data;
            this.item = [];
            this.documentResp = this.documents;
            this.selectFolder = args;
            this.fileView = 1;
            this.onLoadBreadcrumb ();
            this.showOptions = false;
            this.item = id;
            this.onDeleteFile();
          })
          .catch (() => {
            this.$store.dispatch ('isLoadingOff');
          });

      console.log(args);
      //this.selectFolder=args;
      //this.onLoadFolders();
      console.log(id);
    },
    beforeopen: function(args) {
      console.log(args);
      var treevalidate = document.getElementById('treeview').ej2_instances[0];
      var targetNodeId = treevalidate.selectedNodes[0];
      var targetNode = document.querySelector('[data-uid="' + targetNodeId + '"]');
      var contentmenutree = document.getElementById('contentmenutree').ej2_instances[0];
      if (targetNode.classList.contains('borrar')) {
        contentmenutree.enableItems(['Borrar Carpeta'], false);
      }
      else {
        contentmenutree.enableItems(['Borrar Carpeta'], true);
      }
      if (targetNode.classList.contains('renombrar')) {
        contentmenutree.enableItems(['Renombrar Carpeta'], false);
      }
      else {
        contentmenutree.enableItems(['Renombrar Carpeta'], true);
      }
    },
    onEditing(args) {

      console.log(args);
      console.log("onEditing");
      var treeObj = document.getElementById('treeview').ej2_instances[0];
      treeObj.selectedNodes = [args.node.getAttribute('data-uid')];
      console.log(args.node);
      //check whether node is root node or not
      /*if (args.node.parentNode.parentNode.nodeName !== "LI") {
        args.cancel = true;
      }*/
      this.onSaveFolder();
    },
    onDragStop (args)
    {
      console.log("onDragStop");
      let document_id = args.draggedNodeData.id;
      let parent_id = args.droppedNodeData.id;
      if (parent_id != document_id)
      {
        this.$axios.put ("/documents/" + document_id, {'parent_id' : parent_id})
            .then (() => {
              this.onRefresh ()
            })
      }
    },
    loadTemplateDocumentation ()
    {
      this.$axios("/template_request_documentation")
          .then((response)=>{
            this.templates = response.data;
          })
    },
    convertCurrency (amount)
    {
      return new Intl.NumberFormat ('de-DE', { style: 'currency', currency: 'EUR' }).format(amount);
    },
    sortBy: function(sortKey){
      console.log(sortKey);

      this.reverse = (this.sortKey == sortKey) ? ! this.reverse : false;

      this.sortKey = sortKey;
    },
    isActive: function(column){
      return this.sortKey == column;
    }
  }
}

const notInArr = function notInArr(item) {
  return this.indexOf(item) === -1
}

function addCheckedSubset(current, add) {
  if (!current.length) return add

  // Add only messages which are not already checked
  return current.concat(add.filter(notInArr, current))
}

function removeCheckedSubset(current, remove) {
  // Return only messages which are not in subset
  return current.filter(notInArr, remove)
}

</script>

<style>
.right
{
  right: 0;
  position: absolute;
}
fieldset[disabled]{
  background: #f7f7f7;
}
fieldset[disabled] .e-input {
  background: #f8f8f8 !important;
}
#dropzone{
  height: 565px !important;
}
.rotate90{
  transform :rotate(90deg);
  width: 60px;
  padding: 0;
  margin: 0;
  position: absolute;
  left: 2px;
  top: 70px;
}
.step-circle{
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.contentItems{
  max-height: 400px;
  overflow: hidden scroll ;
}
.contentListItem{
  height: 570px;
  overflow: hidden scroll ;
}
.request .breadcrumb{
  margin-bottom: 0;
}
.bg-gray{
  background: #e9ecef;
}
button.bg-gray:focus {
  outline: none;
}
.itemRequest{
  min-height: 35px;
}
.checkItem{
  font-size: 22px;
}
.form-check .form-check-label{
  line-height: 20px;
}
.form-control:focus{
  border-color:  #E3E3E3;
}
.form-group{
  margin-bottom : 5px;
}
.contentFolder .form-group{
  margin-bottom : 0px;
}
.breadcrumb{
  cursor: pointer;
}
.directory .e-list-parent:first-child{
  min-height: 560px;
}
#treeview,
.treeview
{
  max-height: 580px !important;
  overflow: hidden scroll;
}
span.e-list-text {
  text-transform: uppercase;
}
.text-purple{
  color: rgb(50, 49, 48);
  font-weight: bold;
}
.btn-file, .btn-file:focus, .btn-file:hover {
  border: none !important;
  background-color: transparent;
  outline: none;
}
.ItemRequest .table td{
  padding: 8px 8px;
}
.btn-file:hover{
  background-color: #f0f0f0;
}
.font50{
  font-size: 50px;
}
.fonticon110{
  font-size: 110px;
}
.text14{
  font-size: 14px;
}
.h-600{
  min-height: 600px;
}
.folder-icon{
  color: #eac559;
}
.text16{
  font-size: 16px;
}
.p-25{
  padding: 0.8rem;
}
.h-40{
  min-height: 40px;
}
/*Icons */
.e-list-icon {
  display: block;
  height: 40px;
  width: 40px;
  background-size: 30px 30px;
  background-position: center;
}
.e-fe-pdf {
  background-image: url("https://modernb.akamai.odsp.cdn.office.net/files/fabric-cdn-prod_20211207.001/assets/item-types/20/pdf.svg");
  /*background-image: url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZjNlM2U7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNmZmNjY2I7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9QREY8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyLDBINEEyLDIsMCwwLDAsMiwyVjMwYTIsMiwwLDAsMCwyLDJIMjhhMiwyLDAsMCwwLDItMlY4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTEwLjI5LDE0LjgxQTIuNDcsMi40NywwLDAsMSwxMS40LDE1YTIsMiwwLDAsMSwuNzIuNTgsMi4yNCwyLjI0LDAsMCwxLC40LjgyLDMuODEsMy44MSwwLDAsMSwuMTIuOTUsMy4xMSwzLjExLDAsMCwxLS4yLDEuMTUsMiwyLDAsMCwxLS41NS44LDIuMjQsMi4yNCwwLDAsMS0uODYuNDdBMy44NiwzLjg2LDAsMCwxLDkuOTIsMjBIOXYzLjQySDcuMjZWMTQuODFabS0uNTMsMy44N2ExLjEyLDEuMTIsMCwwLDAsLjgzLS4zMSwxLjI4LDEuMjgsMCwwLDAsLjMyLTEsMS41MywxLjUzLDAsMCwwLS4yNy0xLDEuMTQsMS4xNCwwLDAsMC0uOTMtLjM0SDl2Mi42WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTE2LjQxLDE0LjgxYTMuMTcsMy4xNywwLDAsMSwxLjQ1LjI5LDIuMTcsMi4xNywwLDAsMSwuODYuODQsMy44LDMuOCwwLDAsMSwuNDEsMS4zMkExMi42LDEyLjYsMCwwLDEsMTkuMjQsMTlhMTIuMzMsMTIuMzMsMCwwLDEtLjE0LDIsMy43OSwzLjc5LDAsMCwxLS40NywxLjM4LDIuMSwyLjEsMCwwLDEtLjkuOCwzLjMyLDMuMzIsMCwwLDEtMS40My4yN0gxMy41OFYxNC44MVptLS4zNCw3LjI5QTEuNSwxLjUsMCwwLDAsMTYuOCwyMmExLjA5LDEuMDksMCwwLDAsLjQ0LS41MiwzLDMsMCwwLDAsLjIyLS45NWMwLS4zOS4wNS0uODguMDUtMS40NmExMi4wOCwxMi4wOCwwLDAsMC0uMDUtMS4yOCwzLjA5LDMuMDksMCwwLDAtLjE5LS45MiwxLjEzLDEuMTMsMCwwLDAtLjQ1LS41NSwxLjQxLDEuNDEsMCwwLDAtLjc4LS4xOUgxNS4zdjZaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjUuMTcsMTQuODF2MS40MUgyMi4xMXYySDI1djEuNDJIMjIuMTF2My43MkgyMC4zOFYxNC44MVoiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0yMiwwVjdhMSwxLDAsMCwwLDEsMWg3WiIvPjwvc3ZnPg==);*/
  background-repeat: no-repeat;
}
.e-fe-docx {
  background-image: url("https://modernb.akamai.odsp.cdn.office.net/files/fabric-cdn-prod_20211207.001/assets/item-types/20/docx.svg");
  /*background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMwMDhmZTc7fS5jbHMtMntmaWxsOiNhN2RkZmY7fS5jbHMtM3tmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9Xb3JkPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yMiwwSDRBMiwyLDAsMCwwLDIsMlYzMGEyLDIsMCwwLDAsMiwySDI4YTIsMiwwLDAsMCwyLTJWOFoiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0yMiwwVjZhMiwyLDAsMCwwLDIsMmg2WiIvPjxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iNyIgeT0iMjIiIHdpZHRoPSIxOCIgaGVpZ2h0PSIyIi8+PHJlY3QgY2xhc3M9ImNscy0zIiB4PSI3IiB5PSIxNiIgd2lkdGg9IjE4IiBoZWlnaHQ9IjIiLz48cmVjdCBjbGFzcz0iY2xzLTMiIHg9IjciIHk9IjEwIiB3aWR0aD0iMTEiIGhlaWdodD0iMiIvPjwvc3ZnPg==");*/
  background-repeat: no-repeat;
}
.e-fe-pptx {
  background-image: url("https://modernb.akamai.odsp.cdn.office.net/files/fabric-cdn-prod_20211207.001/assets/item-types/20/pptx.svg");
  /*background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZDY2MDA7fS5jbHMtMntmaWxsOiNmZmNkYWE7fS5jbHMtM3tmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9QUHQ8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyLDBINEEyLDIsMCwwLDAsMiwyVjMwYTIsMiwwLDAsMCwyLDJIMjhhMiwyLDAsMCwwLDItMlY4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTIyLDBWN2ExLDEsMCwwLDAsMSwxaDdaIi8+PHJlY3QgY2xhc3M9ImNscy0zIiB4PSI3IiB5PSIyMiIgd2lkdGg9IjE3IiBoZWlnaHQ9IjIiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0xNiw5aDBhNSw1LDAsMCwxLDUsNXYwYTAsMCwwLDAsMSwwLDBIMTZhMCwwLDAsMCwxLDAsMFY5QTAsMCwwLDAsMSwxNiw5WiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTE2LDE2SDE0VjEwLjNBNC44MSw0LjgxLDAsMSwwLDE5LjcsMTZaIi8+PC9zdmc+");*/
  background-repeat: no-repeat;
}
.e-fe-xlsx {
  background-image: url("https://modernb.akamai.odsp.cdn.office.net/files/fabric-cdn-prod_20211207.001/assets/item-types/20/xlsx.svg");
  /*background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMyZWI5ODg7fS5jbHMtMntmaWxsOiM5MmVjY2E7fS5jbHMtM3tmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9FeGNlbDwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjIsMEg0QTIsMiwwLDAsMCwyLDJWMzBhMiwyLDAsMCwwLDIsMkgyOGEyLDIsMCwwLDAsMi0yVjhaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjIsMFY3YTEsMSwwLDAsMCwxLDFoN1oiLz48cmVjdCBjbGFzcz0iY2xzLTMiIHg9IjciIHk9IjE2IiB3aWR0aD0iMTciIGhlaWdodD0iMiIvPjxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iOSIgeT0iMTYiIHdpZHRoPSIxNCIgaGVpZ2h0PSIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMyAxKSByb3RhdGUoOTApIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMjUsMjRIN1YxMEgyNVpNOSwyMkgyM1YxMkg5WiIvPjwvc3ZnPg==");*/
  background-repeat: no-repeat;
}
.e-fe-image {
  background-image: url("data:image/svg+xml;base64,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");
  background-repeat: no-repeat;
}
.e-fe-rar {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNjMzcxYmQ7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNmZmNjZmU7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9SQVI8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyLDBINEEyLDIsMCwwLDAsMiwyVjMwYTIsMiwwLDAsMCwyLDJIMjhhMiwyLDAsMCwwLDItMlY4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTkuNzgsMTQuODFhMi40MiwyLjQyLDAsMCwxLDEuNjguNTQsMi4xNiwyLjE2LDAsMCwxLC42LDEuNjcsMi42MywyLjYzLDAsMCwxLS4zNCwxLjQxLDEuNjgsMS42OCwwLDAsMS0xLjA4Ljd2MGExLjYyLDEuNjIsMCwwLDEsLjk0LjQyQTEuODIsMS44MiwwLDAsMSwxMiwyMC42MmMwLC4xNiwwLC4zMywwLC41MnMwLC40LDAsLjYzYTEwLjQsMTAuNCwwLDAsMCwuMDcsMSwuNjYuNjYsMCwwLDAsLjMxLjQ5di4wOEgxMC41M2EuODcuODcsMCwwLDEtLjE3LS40MmMwLS4xNSwwLS4zMiwwLS40OGwtLjA1LTEuNjVBMS4zMywxLjMzLDAsMCwwLDEwLDIwYS45My45MywwLDAsMC0uNzctLjI5SDguMzJ2My42M0g2LjU5VjE0LjgxWk05LDE4LjU1YTEuNDMsMS40MywwLDAsMCwxLS4yOSwxLjI5LDEuMjksMCwwLDAsLjM0LTEsMS4wNiwxLjA2LDAsMCwwLTEuMi0xLjE5SDguMzJ2Mi40N1oiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0xNy4wNywxNC44MWwyLjI3LDguNTdoLTEuOGwtLjQtMS44MkgxNC44NmwtLjQsMS44MmgtMS44bDIuMjctOC41N1ptLS4yMyw1LjM0TDE2LDE2LjNoMGwtLjgzLDMuODVaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjMuMTMsMTQuODFhMi40MiwyLjQyLDAsMCwxLDEuNjguNTQsMi4xNiwyLjE2LDAsMCwxLC42LDEuNjcsMi42MywyLjYzLDAsMCwxLS4zNSwxLjQxLDEuNjMsMS42MywwLDAsMS0xLjA4Ljd2MGExLjY1LDEuNjUsMCwwLDEsLjk1LjQyLDEuODMsMS44MywwLDAsMSwuMzcsMS4wNWMwLC4xNiwwLC4zMywwLC41MnMwLC40LDAsLjYzYzAsLjQ1LDAsLjguMDcsMWEuNjYuNjYsMCwwLDAsLjMxLjQ5di4wOEgyMy44N0ExLDEsMCwwLDEsMjMuNywyM2EzLjczLDMuNzMsMCwwLDEsMC0uNDhsLS4wNS0xLjY1YTEuNCwxLjQsMCwwLDAtLjI1LS43OSwxLDEsMCwwLDAtLjc3LS4yOWgtLjkzdjMuNjNIMTkuOTRWMTQuODFabS0uNzUsMy43NGExLjQzLDEuNDMsMCwwLDAsMS0uMjksMS4yNSwxLjI1LDAsMCwwLC4zNC0xLDEuMDYsMS4wNiwwLDAsMC0xLjItMS4xOWgtLjgydjIuNDdaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMjIsMFY3YTEsMSwwLDAsMCwxLDFoN1oiLz48L3N2Zz4=");
  background-repeat: no-repeat;
}
.e-fe-zip {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmMjljMWY7fS5jbHMtMntmaWxsOiNmZmVmY2M7fS5jbHMtM3tmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9aaXA8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyLDBINEEyLDIsMCwwLDAsMiwyVjMwYTIsMiwwLDAsMCwyLDJIMjhhMiwyLDAsMCwwLDItMlY4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTIyLDBWN2ExLDEsMCwwLDAsMSwxaDdaIi8+PHJlY3QgY2xhc3M9ImNscy0zIiB4PSI2IiB5PSI3IiB3aWR0aD0iMTMiIGhlaWdodD0iMiIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMyIgcG9pbnRzPSIxMi41IDI4IDYgMjIgMTkgMjIgMTIuNSAyOCIvPjxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iNiIgeT0iMTIiIHdpZHRoPSIxMyIgaGVpZ2h0PSIyIi8+PHJlY3QgY2xhc3M9ImNscy0zIiB4PSI2IiB5PSIxNyIgd2lkdGg9IjEzIiBoZWlnaHQ9IjIiLz48L3N2Zz4=");
  background-repeat: no-repeat;
}
.e-fe-txt {
  background-repeat: no-repeat;
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNhYWE7fS5jbHMtMntmaWxsOiNlY2VjZWM7fS5jbHMtM3tmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9UZXh0PC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yMiwwSDRBMiwyLDAsMCwwLDIsMlYzMGEyLDIsMCwwLDAsMiwySDI4YTIsMiwwLDAsMCwyLTJWOFoiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0yMiwwVjdhMSwxLDAsMCwwLDEsMWg3WiIvPjxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iNyIgeT0iMjIiIHdpZHRoPSIxOCIgaGVpZ2h0PSIyIi8+PHJlY3QgY2xhc3M9ImNscy0zIiB4PSI3IiB5PSIxNiIgd2lkdGg9IjE4IiBoZWlnaHQ9IjIiLz48cmVjdCBjbGFzcz0iY2xzLTMiIHg9IjciIHk9IjEwIiB3aWR0aD0iMTEiIGhlaWdodD0iMiIvPjwvc3ZnPg==");
}
.e-fe-music {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMwMDhmZTc7fS5jbHMtMntmaWxsOiNhN2RkZmY7fS5jbHMtM3tmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9NdXNpYzwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjIsMEg0QTIsMiwwLDAsMCwyLDJWMzBhMiwyLDAsMCwwLDIsMkgyOGEyLDIsMCwwLDAsMi0yVjhaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjIsMFY3YTEsMSwwLDAsMCwxLDFoN1oiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0xMiwxMy41M1YyMWEyLjUsMi41LDAsMCwwLTMuOSwxLjI4LDIuNTEsMi41MSwwLDAsMCwyLjc4LDMuMThBMi41OCwyLjU4LDAsMCwwLDEzLDIyLjg4VjE2LjU2bDEwLTEuODRWMTlhMi41LDIuNSwwLDAsMC0zLjksMS4yOCwyLjUxLDIuNTEsMCwwLDAsMi43OCwzLjE4QTIuNTgsMi41OCwwLDAsMCwyNCwyMC44OFYxMS43YTEsMSwwLDAsMC0xLjE4LTFsLTEwLDEuODNBMSwxLDAsMCwwLDEyLDEzLjUzWiIvPjwvc3ZnPg==");
  background-repeat: no-repeat;
}
.e-fe-video {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmMTAzMDA7fS5jbHMtMntmaWxsOiNmZmNjY2I7fS5jbHMtM3tmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9WaWRlbzwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjIsMEg0QTIsMiwwLDAsMCwyLDJWMzBhMiwyLDAsMCwwLDIsMkgyOGEyLDIsMCwwLDAsMi0yVjhaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjIsMFY3YTEsMSwwLDAsMCwxLDFoN1oiLz48cG9seWdvbiBjbGFzcz0iY2xzLTMiIHBvaW50cz0iMTUgMTQuNSAxOSAxOCAxNSAyMS41IDE1IDE0LjUiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0yMiwyNUgxMGEzLDMsMCwwLDEtMy0zVjE0YTMsMywwLDAsMSwzLTNIMjJhMywzLDAsMCwxLDMsM3Y4QTMsMywwLDAsMSwyMiwyNVpNMTAsMTNhMSwxLDAsMCwwLTEsMXY4YTEsMSwwLDAsMCwxLDFIMjJhMSwxLDAsMCwwLDEtMVYxNGExLDEsMCwwLDAtMS0xWiIvPjwvc3ZnPg==");
  background-repeat: no-repeat;
}
.e-fe-js {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM4MmJiMjI7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNlOWZmYjg7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9KUzwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjIsMEg0QTIsMiwwLDAsMCwyLDJWMzBhMiwyLDAsMCwwLDIsMkgyOGEyLDIsMCwwLDAsMi0yVjhaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTUuMTQsMjFhMi41NywyLjU3LDAsMCwxLS42NCwxLjk1LDIuODMsMi44MywwLDAsMS0xLjk0LjU4LDIuODQsMi44NCwwLDAsMS0xLjEzLS4xOSwxLjYsMS42LDAsMCwxLS42OS0uNTMsMiwyLDAsMCwxLS4zNi0uNzksNSw1LDAsMCwxLS4wOS0xdi0uMzhoMS41OHYuMjdhMi41OCwyLjU4LDAsMCwwLC4xNSwxLC42MS42MSwwLDAsMCwuNjIuMzMuNjEuNjEsMCwwLDAsLjYyLS4zMywyLjU4LDIuNTgsMCwwLDAsLjE1LTFWMTQuODFoMS43M1oiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0xNy42NiwyMWEzLjE2LDMuMTYsMCwwLDAsMCwuNTUsMS4xOSwxLjE5LDAsMCwwLC4xOC40MSwxLDEsMCwwLDAsLjM2LjI3LDEuNDksMS40OSwwLDAsMCwuNTYuMDksMS4wNiwxLjA2LDAsMCwwLC43MS0uMjYsMSwxLDAsMCwwLC4zMi0uNzksMS40NiwxLjQ2LDAsMCwwLS4wOC0uNSwxLDEsMCwwLDAtLjI2LS4zOEEyLjI1LDIuMjUsMCwwLDAsMTksMjBjLS4yLS4wOS0uNDQtLjE4LS43My0uMjhhNi43LDYuNywwLDAsMS0xLS40MiwyLjgsMi44LDAsMCwxLS43MS0uNTMsMi4xLDIuMSwwLDAsMS0uNDEtLjcxLDIuOTQsMi45NCwwLDAsMS0uMTMtLjkzLDIuMzgsMi4zOCwwLDAsMSwuNzEtMS45LDIuODYsMi44NiwwLDAsMSwxLjk0LS42Miw0LDQsMCwwLDEsMS4wNi4xMywyLjE5LDIuMTksMCwwLDEsLjg0LjQsMS44NywxLjg3LDAsMCwxLC41NS43MiwyLjQ2LDIuNDYsMCwwLDEsLjIsMS4wNXYuMjRIMTkuN2ExLjc2LDEuNzYsMCwwLDAtLjIyLS45NC43OS43OSwwLDAsMC0uNzItLjMzLDEuMTQsMS4xNCwwLDAsMC0uNDguMDkuNzkuNzksMCwwLDAtLjMxLjIyLjg2Ljg2LDAsMCwwLS4xNS4zMiwxLjUsMS41LDAsMCwwLDAsLjM3LDEuMjQsMS4yNCwwLDAsMCwuMTYuNjYsMS41OCwxLjU4LDAsMCwwLC43Mi41bDEuMzQuNThhMy45MywzLjkzLDAsMCwxLC44LjQ1LDIuMTUsMi4xNSwwLDAsMSwuNS41LDEuNzksMS43OSwwLDAsMSwuMjYuNiwzLjgyLDMuODIsMCwwLDEsLjA3LjcyLDIuMzQsMi4zNCwwLDAsMS0uNzksMiwzLjQ2LDMuNDYsMCwwLDEtMi4xOS42MiwyLjg0LDIuODQsMCwwLDEtMi4wOS0uNjQsMi40NywyLjQ3LDAsMCwxLS42My0xLjgyVjIwLjdoMS43M1oiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0yMiwwVjdhMSwxLDAsMCwwLDEsMWg3WiIvPjwvc3ZnPg==");
  background-repeat: no-repeat;
}
.e-fe-css {
  background-image: url("data:image/svg+xml;base64,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");
  background-repeat: no-repeat;
}
.e-fe-html {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM4MjNhOWI7fS5jbHMtMntmaWxsOiNlY2JkZmY7fS5jbHMtM3tmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9IVE1MPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yMiwwSDRBMiwyLDAsMCwwLDIsMlYzMGEyLDIsMCwwLDAsMiwySDI4YTIsMiwwLDAsMCwyLTJWOFoiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0yMiwwVjdhMSwxLDAsMCwwLDEsMWg3WiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTIwLjY0LDI2Ljc3bC0xLjI4LTEuNTRMMjQuNDQsMjFsLTUuMDgtNC4yMywxLjI4LTEuNTQsNiw1YTEsMSwwLDAsMSwwLDEuNTRaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMTEuMjgsMjYuNzdsLTYtNWExLDEsMCwwLDEsMC0xLjU0bDYtNSwxLjI4LDEuNTRMNy40OCwyMWw1LjA4LDQuMjNaIi8+PHJlY3QgY2xhc3M9ImNscy0zIiB4PSI3Ljc1IiB5PSIyMCIgd2lkdGg9IjE2LjQ5IiBoZWlnaHQ9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04LjI2IDMxLjQyKSByb3RhdGUoLTc1Ljk1KSIvPjwvc3ZnPg==");
  background-repeat: no-repeat;
}
.e-fe-php {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM3MzcxY2M7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNkY2RjZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9QSFA8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyLDBINEEyLDIsMCwwLDAsMiwyVjMwYTIsMiwwLDAsMCwyLDJIMjhhMiwyLDAsMCwwLDItMlY4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTEwLjA2LDE0LjgxYTIuNDcsMi40NywwLDAsMSwxLjExLjIyLDIuMTEsMi4xMSwwLDAsMSwuNzMuNTgsMi4zOSwyLjM5LDAsMCwxLC4zOS44MiwzLjgxLDMuODEsMCwwLDEsLjEyLjk1LDIuOTIsMi45MiwwLDAsMS0uMiwxLjE1LDIsMiwwLDAsMS0uNTUuOCwyLjE3LDIuMTcsMCwwLDEtLjg2LjQ3QTMuODEsMy44MSwwLDAsMSw5LjY5LDIwSDguNzZ2My40Mkg3VjE0LjgxWm0tLjUzLDMuODdhMS4xNSwxLjE1LDAsMCwwLC44NC0uMzEsMS4zMiwxLjMyLDAsMCwwLC4zMS0xLDEuNTMsMS41MywwLDAsMC0uMjctMSwxLjEzLDEuMTMsMCwwLDAtLjkzLS4zNEg4Ljc2djIuNloiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0xNSwxNC44MXYzLjI3aDJWMTQuODFoMS43M3Y4LjU3SDE3VjE5LjU3SDE1djMuODFIMTMuMjZWMTQuODFaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjMsMTQuODFhMi40NywyLjQ3LDAsMCwxLDEuMTEuMjIsMi4xMSwyLjExLDAsMCwxLC43My41OCwyLjM5LDIuMzksMCwwLDEsLjM5LjgyLDMuODEsMy44MSwwLDAsMSwuMTIuOTUsMi45MiwyLjkyLDAsMCwxLS4yLDEuMTUsMiwyLDAsMCwxLS41NS44LDIuMTcsMi4xNywwLDAsMS0uODYuNDcsMy44MSwzLjgxLDAsMCwxLTEuMTEuMTZoLS45M3YzLjQySDE5Ljk0VjE0LjgxWm0tLjUzLDMuODdhMS4xNSwxLjE1LDAsMCwwLC44NC0uMzEsMS4zMiwxLjMyLDAsMCwwLC4zMS0xLDEuNTMsMS41MywwLDAsMC0uMjctMSwxLjEzLDEuMTMsMCwwLDAtLjkzLS4zNGgtLjcydjIuNloiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0yMiwwVjdhMSwxLDAsMCwwLDEsMWg3WiIvPjwvc3ZnPg==");
  background-repeat: no-repeat;
}
.e-fe-exe {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM0YjQ4NGM7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNkNmQ2ZDY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9FeGU8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyLDBINEEyLDIsMCwwLDAsMiwyVjMwYTIsMiwwLDAsMCwyLDJIMjhhMiwyLDAsMCwwLDItMlY4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTExLjgyLDE2LjIySDguNzZ2MmgyLjg4djEuNDJIOC43NlYyMmgzLjE4djEuNDJIN1YxNC44MWg0Ljc4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTE0LjM2LDE0LjgxbDEuMSwyLjc3LDEuMDktMi43N2gxLjg5bC0yLDQuMjMsMi4xNCw0LjM0SDE2LjY0TDE1LjQsMjAuNDdsLTEuMjIsMi45MWgtMS45TDE0LjQyLDE5bC0yLTQuMjNaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjQsMTYuMjJIMjF2MmgyLjg4djEuNDJIMjFWMjJoMy4xOHYxLjQySDE5LjI1VjE0LjgxSDI0WiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTIyLDBWN2ExLDEsMCwwLDAsMSwxaDdaIi8+PC9zdmc+");
  background-repeat: no-repeat;
}
.e-fe-msi {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM0ZGJjYzE7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNhZmVmZWQ7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9NU0k8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyLDBINEEyLDIsMCwwLDAsMiwyVjMwYTIsMiwwLDAsMCwyLDJIMjhhMiwyLDAsMCwwLDItMlY4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTkuNjQsMTQuODFsMS4yMiw2aDBsMS4yMy02aDIuNTZ2OC41N0gxMy4xVjE2LjU0aDBsLTEuNTIsNi44NEgxMC4yTDguNjgsMTYuNTRoMHY2Ljg0SDcuMDdWMTQuODFaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTcuMzEsMjFhMi4zOSwyLjM5LDAsMCwwLC4wNS41NS45LjksMCwwLDAsLjE4LjQxLjg5Ljg5LDAsMCwwLC4zNS4yNywxLjQ5LDEuNDksMCwwLDAsLjU2LjA5LDEuMDYsMS4wNiwwLDAsMCwuNzEtLjI2LDEsMSwwLDAsMCwuMzItLjc5LDEuNDYsMS40NiwwLDAsMC0uMDgtLjUsMSwxLDAsMCwwLS4yNi0uMzgsMiwyLDAsMCwwLS40Ny0uMzFjLS4yLS4wOS0uNDQtLjE4LS43My0uMjhhNi43LDYuNywwLDAsMS0xLS40MiwyLjU4LDIuNTgsMCwwLDEtLjctLjUzLDIsMiwwLDAsMS0uNDItLjcxLDIuOTQsMi45NCwwLDAsMS0uMTMtLjkzLDIuNDIsMi40MiwwLDAsMSwuNzEtMS45LDIuODYsMi44NiwwLDAsMSwxLjk0LS42MiwzLjksMy45LDAsMCwxLDEuMDYuMTMsMi4xOSwyLjE5LDAsMCwxLC44NC40LDIsMiwwLDAsMSwuNTYuNzJBMi42MiwyLjYyLDAsMCwxLDIxLDE2Ljk0di4yNEgxOS4zNWExLjY4LDEuNjgsMCwwLDAtLjIyLS45NC43OS43OSwwLDAsMC0uNzItLjMzLDEuMTQsMS4xNCwwLDAsMC0uNDguMDkuNjkuNjksMCwwLDAtLjMuMjIuNzQuNzQsMCwwLDAtLjE2LjMyLDEuNSwxLjUsMCwwLDAsMCwuMzcsMS4xNiwxLjE2LDAsMCwwLC4xNy42NiwxLjQ3LDEuNDcsMCwwLDAsLjcyLjVsMS4zMy41OGEzLjY3LDMuNjcsMCwwLDEsLjguNDUsMiwyLDAsMCwxLC41LjUsMS43OSwxLjc5LDAsMCwxLC4yNi42LDMuMTQsMy4xNCwwLDAsMSwuMDcuNzIsMi4zNCwyLjM0LDAsMCwxLS43OSwyLDMuNDYsMy40NiwwLDAsMS0yLjE5LjYyLDIuODQsMi44NCwwLDAsMS0yLjA5LS42NCwyLjQ3LDIuNDcsMCwwLDEtLjYzLTEuODJWMjAuN2gxLjczWiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTIyLjIzLDE0LjgxSDI0djguNTdIMjIuMjNaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMjIsMFY3YTEsMSwwLDAsMCwxLDFoN1oiLz48L3N2Zz4=");
  background-repeat: no-repeat;
}
.e-fe-unknown {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZjg2MmM7fS5jbHMtMntvcGFjaXR5OjAuNDU7fS5jbHMtM3tmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9FeGNsYW1hdG9yeTwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjIsMEg0QTIsMiwwLDAsMCwyLDJWMzBhMiwyLDAsMCwwLDIsMkgyOGEyLDIsMCwwLDAsMi0yVjhaIi8+PGcgY2xhc3M9ImNscy0yIj48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0yMiwwVjdhMSwxLDAsMCwwLDEsMWg3WiIvPjwvZz48cG9seWdvbiBjbGFzcz0iY2xzLTMiIHBvaW50cz0iMTcuNDcgMjAgMTQuNSAyMCAxNCA4IDE4IDggMTcuNDcgMjAiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMyIgY3g9IjE2IiBjeT0iMjQiIHI9IjIiLz48L3N2Zz4=");
  background-repeat: no-repeat;
}
.e-fe-rtf {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMwMDkwZDg7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNjNWVmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9SVEY8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyLDBINEEyLDIsMCwwLDAsMiwyVjMwYTIsMiwwLDAsMCwyLDJIMjhhMiwyLDAsMCwwLDItMlY4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTExLjIzLDE0LjgxYTIuNDIsMi40MiwwLDAsMSwxLjY4LjU0LDIuMTYsMi4xNiwwLDAsMSwuNiwxLjY3LDIuNjMsMi42MywwLDAsMS0uMzUsMS40MSwxLjYzLDEuNjMsMCwwLDEtMS4wOC43djBhMS42NSwxLjY1LDAsMCwxLC45NS40MiwxLjgzLDEuODMsMCwwLDEsLjM3LDEuMDVjMCwuMTYsMCwuMzMsMCwuNTJzMCwuNCwwLC42M2MwLC40NSwwLC44LjA3LDFhLjY2LjY2LDAsMCwwLC4zMS40OXYuMDhIMTJBMSwxLDAsMCwxLDExLjgsMjNhMy43MywzLjczLDAsMCwxLDAtLjQ4bDAtMS42NWExLjQsMS40LDAsMCwwLS4yNS0uNzksMSwxLDAsMCwwLS43Ny0uMjlIOS43NnYzLjYzSDhWMTQuODFabS0uNzUsMy43NGExLjQzLDEuNDMsMCwwLDAsMS0uMjksMS4yNSwxLjI1LDAsMCwwLC4zNC0xLDEuMDYsMS4wNiwwLDAsMC0xLjItMS4xOUg5Ljc2djIuNDdaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTkuNTEsMTYuMjJIMTcuNjR2Ny4xNkgxNS45MVYxNi4yMkgxNFYxNC44MWg1LjQ3WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTI1LDE0LjgxdjEuNDFIMjJ2MmgyLjg4djEuNDJIMjJ2My43MkgyMC4yNVYxNC44MVoiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0yMiwwVjdhMSwxLDAsMCwwLDEsMWg3WiIvPjwvc3ZnPg==");
  background-repeat: no-repeat;
}
.e-fe-xml {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMyMjc5NGE7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNjYWZmZTE7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9YTUw8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyLDBINEEyLDIsMCwwLDAsMiwyVjMwYTIsMiwwLDAsMCwyLDJIMjhhMiwyLDAsMCwwLDItMlY4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTcuNzEsMTQuODFsMS4xLDIuNzdMOS45LDE0LjgxaDEuODlMOS44LDE5bDIuMTMsNC4zNEgxMEw4Ljc1LDIwLjQ3LDcuNTMsMjMuMzhINS42M0w3Ljc3LDE5bC0yLTQuMjNaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTUuMjEsMTQuODFsMS4yMiw2aDBsMS4yMy02aDIuNTZ2OC41N0gxOC42NlYxNi41NGgwbC0xLjUyLDYuODRIMTUuNzdsLTEuNTItNi44NGgwdjYuODRIMTIuNjRWMTQuODFaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjEuNDgsMTQuODFoMS43M1YyMmgzLjA2djEuNDJIMjEuNDhaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMjIsMFY3YTEsMSwwLDAsMCwxLDFoN1oiLz48L3N2Zz4=");
  background-repeat: no-repeat;
}
.e-switch-wrapper {
  height: 25px;
  width: 50px;
}
.e-switch-wrapper input{
  display: none;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: #e1e1e1;
  border-color: #e1e1e1;
  font-weight: bold;
}
.nav-tabs{
  text-transform: uppercase;
  font-size: 20px;
  color: #495057;
  cursor: pointer;
}
.nav .nav-item .nav-link:hover, .nav .nav-item .nav-link:focus {
  background-color: #fafafa;
}
.request .nav-link{
  padding: 0.4rem 0.5rem;
}
.item-request
{
  font-size: 12px;
  cursor: pointer;
  transition: all .5s cubic-bezier(.34,1.61,.7,1);
  color: #343A40;
}
.item-request:hover
{
  background-color: #F5F5F5;
}
.item-request-active
{
  color: #FFF;
  background-color: #317AB9;
}

#elipse_div{
  max-width: 200px;
  width:100%;
  /*border:1px solid black;*/
  overflow:hidden;
  white-space: nowrap;
}
#elipse_div span:hover{text-decoration: underline}
/*********************************/
.toggle {
  text-decoration: none;
  font-size: 1.2em !important;
  color: rgba(0, 0, 0, 0.61);
  -webkit-transition: all 0.15s ease-out 0;
  -moz-transition: all 0.15s ease-out 0;
  transition: all 0.45s ease-out 0;
  position: absolute;
  left: 10px;
  z-index: 1;
  cursor: pointer;
}
/******************************/

.sidebar2 {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: -220px;
  -webkit-transition: all 0.15s ease-out 0;
  -moz-transition: all 0.15s ease-out 0;
  transition: all 0.15s ease-out 0;
  width: 14rem;
}

.sidebar2 a:hover {
  color: rgba(0, 0, 0, 0.61);
}

#slide:checked + .container .sidebar2 {
  left: 0px;
}

#slide:checked + .container .toggle {
  left: 215px;
}

#slide {
  display: none;
}
#treeview ul{
  padding: 0 0 0 10px;}
/*****************************/
.breadcrumb-item + .breadcrumb-item::before{
  content: ">";
}
.breadcrumb-item + .breadcrumb-item {
  padding-left: 0;
}
#treeview ul{
  padding: 0 0 0 10px;
}
.breadcrumb{padding: 0.25rem 0.5rem; margin-bottom: 0;background: transparent;}
.menu-btn {
  display: none;
  position: relative;
  top: 50%;
  left: 100%;
  width: 30px;
  height: 30px;
  background: url(http://www.movingpixelsdesign.com/codepen/Chevron_btn-left.png) no-repeat;
  background-size: cover;
  cursor: pointer;
}
#label_slide{
  position: relative;
  top: 0;
  left: 0;
  width: 30px;
  height: 30px;
}

/********************************/

.menu-maker, .menu-maker2 {
  display: none;
}
.menu-maker:checked ~ div.treeview
{
  width: 100%;
}

.menu-maker:checked ~ div.sidebar_left
{
  transform: translate3d(0px, 0px, 0px);
}

.menu-holder {
  display: block;
  width: 15px;
  transition: all 0.12s linear;
  -webkit-transition: all 0.12s linear;
  -moz-transition: all 0.12s linear;
  -o-transition: all 0.12s linear;
  -ms-transition: all 0.12s linear;
  left: 0px;
  position: absolute;
}

.menu-holder2 {
  display: block;
  width: 15px;
  transition: all 0.12s linear;
  -webkit-transition: all 0.12s linear;
  -moz-transition: all 0.12s linear;
  -o-transition: all 0.12s linear;
  -ms-transition: all 0.12s linear;
  right: 3px;
  position: absolute;
}

.menu-maker:checked + .menu-holder .hamburger {
  background: transparent;
}

.hamburger {
  position: absolute;
  z-index: 9;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.hamburger .hamburger-toppings {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  margin: 0 auto;
  height: 20px;
}
.hamburger span {
  display: block;
  width: 20px;
  height: 2px;
  margin: 5px auto 0;
  background-color: #ccc;
}
.menu-maker:checked ~ .menu {
  transform: translate3d(0, 0, 0);
}

.container3 {
  transition: all 0.12s linear;
  -webkit-transition: all 0.12s linear;
  -moz-transition: all 0.12s linear;
  -o-transition: all 0.12s linear;
  -ms-transition: all 0.12s linear;
}

.container2 {
  transition: all 0.12s linear;
  -webkit-transition: all 0.12s linear;
  -moz-transition: all 0.12s linear;
  -o-transition: all 0.12s linear;
  -ms-transition: all 0.12s linear;
}
.container2 p {
  margin: 0;
}
.menu-maker:checked ~ .sidebar_left {
  transform: translate3d(0px, 0px, 0px);
}
div.treeview{ background-color: #fff}
.menu-maker:checked ~ .side {
  width: 75%;
}
.menu {
  position: absolute;
  height: 100%;
  width: 270px;
  transform: translate3d(-270px, 0, 0);
  padding-top: 40px;
  transition: all 0.12s linear;
  -webkit-transition: all 0.12s linear;
  -moz-transition: all 0.12s linear;
  -o-transition: all 0.12s linear;
  -ms-transition: all 0.12s linear;
}

.menu-maker:checked + .menu-holder .hamburger .fa-angle-double-right:before {
  content: "\f100";
}
.menu-maker2:checked + .menu-holder2 .hamburger .fa-angle-double-left:before {
  content: "\f101";
}

/**********************************/
.--switch {
  position: relative;
  display: inline-block;
  width: 70px;
  height: 35px;
}

.--switch input {
  display:none;
}

.--slider .fa-list {
  color: #FFFFFF;
  position:absolute;
  left:15px;
  font-size:16px;
  display:none;
}
.--slider .fa-th-large {
  color: #FFFFFF;
  position:absolute;
  font-size:16px;
  right:15px;
}

.--slider {
  position: absolute;
  cursor: pointer;
  display:flex;
  align-items:center;
  top:0;
  left:0;
  right:0;
  bottom:0;
  background-color: #b78d8c;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius:50px;
}

.--slider:before {
  position: absolute;
  content:"";
  height: 27px;
  width: 27px;
  left: 4px;
  bottom: 4px;
  border-radius:50%;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

.--switch input:checked + .--slider .fa-list {
  display:block;
}

.--switch input:checked + .--slider .fa-th-large {
  display:none;
}

.--switch input:checked + .--slider {
  background-color: #93c7b8;
}

.--switch input:focus + .--slider {
  box-shadow: 0 0 1px #93c7b8;
}

.--switch input:checked + .--slider:before {

  -webkit-transform: translateX(35px);
  -ms-transform: translateX(35px);
  transform: translateX(35px);
}

.table a {color: #5d5d5d; flex: 0 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
  font-size: 14px;
}
.mosaic_box {
  flex: 0 0 176px;
  max-width: 176px;
  margin: 4px;
  border-style: none;
  border-width: 0px;
}
.mosaic_checkbox{float: right}
/**************************************/
.second_td{width: 10%}
.first_td {
  width: 50%;
  position: absolute;
}
.ellipsis {
  position: relative;
  float: left;
  width: 75%;
}
#gridView .ellipsis {
  position: relative;
  float: left;
  width: 100%;
}
.ellipsis:before {
  content: '&nbsp;';
  visibility: hidden;
}
.ellipsis span {
  position: absolute;
  left: 0;
  right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.number_files{position: absolute; bottom: 0}
.fa-stack[data-count]:after{
  position:absolute;
  right:0%;
  top:1%;
  content: attr(data-count);
  font-size:15%;
  padding:.6em;
  border-radius:999px;
  line-height:.75em;
  color: white;
  background:rgba(255,0,0,.85);
  text-align:center;
  min-width:2em;
  font-weight:bold;
}
input.mosaic_checkbox{
  position: absolute;
}
.checkbox_label {
  position: relative;
  overflow: hidden;
}

.checkbox__input {
  position: absolute;
  top: -100px;
  left: -100px;
}

.checkbox__inner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #626262;
  background: white no-repeat center;
}

.checkbox__input:checked + .checkbox__inner {
  border-color: white;
  background-color: rgb(73, 130, 5);
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='14px' height='10px' viewBox='0 0 14 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 59.1 (86144) - https://sketch.com --%3E%3Ctitle%3Echeck%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='ios_modification' transform='translate(-27.000000, -191.000000)' fill='%23FFFFFF' fill-rule='nonzero'%3E%3Cg id='Group-Copy' transform='translate(0.000000, 164.000000)'%3E%3Cg id='ic-check-18px' transform='translate(25.000000, 23.000000)'%3E%3Cpolygon id='check' points='6.61 11.89 3.5 8.78 2.44 9.84 6.61 14 15.56 5.05 14.5 4'%3E%3C/polygon%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-size: 10px 10px;
}
/*.card label{position: absolute; right: 0}*/
.checkbox_label{
  position: absolute;
  right: 5px;
}
#listView .checkbox_label{
  position: absolute;
  left: 5px;
  top:40%;
  font-weight: bold;
  width: 20px;
}
#my_documents_list .checkbox_label{
  position: absolute;
  left: 5px;
  top:40%;
  font-weight: bold;
  width: 20px;
}
.sidebar_left{
  padding: 0;
}
/*******************/
/*.wrapper_docs {
  display: flex;
  min-height: 50%;
}

.sidebar_docs {
  transform: translate3d(-300px, 0px, 0px);
  position: absolute;
  width: 25%;
  color: #eee;
  left: 0;
  height: 100%;
  transition: all .3s;
}

.content_docs {
  flex: 1;
  padding: 30px 30px;
  transform: translate3d(0, 0, 0);
  transition: transform .3s;
}

input[data-function*='swipe'] {
  position: absolute;
  opacity: 0;
}

label[data-function*='swipe'] {
  position: absolute;
  top: 30px;
  left: 20px;
  z-index: 1;
  display: block;
  width: 30px;
  height: 30px;
  font: 30px/30px fontawesome;
  text-align: center;
  color: #444;
  cursor: pointer;
  transform: translate3d(0, 0, 0);
  transition: transform .3s;
}

input[data-function*='swipe']:checked ~ label[data-function*='swipe'] {
  transform: translate3d(300px, 0, 0);
}

input[data-function*='swipe']:checked ~ .content_docs {
  transform: translate3d(295px, 0px, 0px);
}

input[data-function*='swipe']:checked ~ .sidebar_docs {
  transform: translate3d(0px, 0px, 0px);
}
input[data-function*='swipe']:checked ~ .sidebar .menu li {
  width: 100%;
}*/
.ellipsis_text{
  width:100%;box-sizing:border-box;overflow:hidden;text-overflow:ellipsis;
  white-space: nowrap;
}
.mosaicBox{
  flex: 0 0 176px;
  max-width: 176px;
  /*min-width: 176px;*/
  margin: 5px;
  border-style: none;
  border-width: 0px;
  padding: 5px;
}

#gridView .e-list-icon{
  height: 50px;
  width: 50px;
  background-size: 50px 50px;
  background-position: center;
}
/***********************************************/

#drawer-left-toggle, #drawer-right-toggle {
  position: absolute;
  opacity: 0;
}

#drawer-left-toggle-label {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  left: 0px;
  height:35px;
  width: 35px;
  display: block;
  background: rgba(255,255,255,.0);
  z-index: 1;
}


#drawer-right-toggle-label {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  right: 0px;
  height:35px;
  width: 35px;
  display: block;
  background: rgba(255,255,255,.0);
  z-index: 1;
}
/* adds our "hamburger" menu icon */

#drawer-left-toggle-label:before {
  content: '';
  display: block;
  position: absolute;
  height: 2px;
  width: 24px;
  background: #8d8d8d;
  left: 13px;
  top: 9px;
  box-shadow: 0 6px 0 #8d8d8d, 0 12px 0 #8d8d8d;
}


#drawer-right-toggle-label:before {
  content: '';
  display: block;
  position: absolute;
  height: 2px;
  width: 24px;
  background: #8d8d8d;
  right: 13px;
  top: 9px;
  box-shadow: 0 6px 0 #8d8d8d, 0 12px 0 #8d8d8d;
}

/* drawer menu pane - note the 0px width */

#drawer_left {
  position: absolute;
  /*top: 0;*/
  left:-260px;
  /*height: 100%;*/
  width: 260px;
  margin-top: 30px;
  -webkit-overflow-scrolling: touch;
  z-index: 9;
}

#drawer_right {
  position: absolute;
  /*top: 0;*/
  right:-340px;
  height: 100%;
  width: 340px;
  /*margin-top: 30px;*/
  -webkit-overflow-scrolling: touch;
  z-index: auto;
}

/* actual page content pane */

#page-content {
  overflow-x: auto;
  margin-left: 0px;
  /*margin-top: 15px;*/
  /*height: calc(100% - 15px);*/
  padding: 0px 15px;
  width: 100%;
}

/* checked styles (menu open state) */

#drawer-left-toggle:checked ~ #drawer-left-toggle-label {
  height: 40px;
  width: 40px;
  /*width: calc(100% - 300px); */
  background: rgba(255,255,255,.8);
}

#drawer-right-toggle:checked ~ #drawer-right-toggle-label {
  height: 40px;
  width: 40px;
  /*width: calc(100% - 300px); */
  background: rgba(255,255,255,.8);
}

#drawer-left-toggle:checked ~ #drawer-left-toggle-label {
  left: 260px;
}

#drawer-right-toggle:checked ~ #drawer-right-toggle-label {
  right: 340px;
}

#menu-maker-id:checked ~ #drawer_left {
  left: 0px;
}

#menu-maker-id2:checked ~ #drawer_right {
  right: 0px;
}

#menu-maker-id:checked ~ #page-content {
  margin-left: 260px;
}

#menu-maker-id2:checked ~ #page-content {
  margin-right: 340px;
}
/****************************/
#my_documents_list > table > thead > tr > th:nth-child(2){
  width: 50px;
  text-align: center !important;
}
#my_documents_list > table > thead > tr > th:nth-child(3){
  width: 40%;
}
#my_documents_list > table > thead > tr > th:nth-child(4){
  width: 30%;
}

/*#listView .table tbody td:first-child, #listView .table thead th:first-child{
  padding-left: 5px;
}*/
#listView > table > thead > tr > th:nth-child(2){
  width: 50px;
  text-align: center !important;
}
#listView > table > thead > tr > th:nth-child(3){
  width: 50%;
}

#listView > table > tbody > tr > td:nth-child(3){
  width: 100%;
}
/*****************************/
/*table.glyphicon-hover .file_actions {
  visibility: hidden;
}
table.glyphicon-hover td:hover .file_actions {
  visibility: visible;
}*/
.file_buttons{
  padding: 0;
  text-align: right;
  list-style: none; margin:0;
  display: inline-flex;
}
.file_buttons li button{
  /*margin-left: 10px;*/
  width: 100%;
  text-align: left;
  border: none;

}
#page-content .dropdown-toggle::after{display: none}
.file_actions{
  float: right;
  position: relative;
  background-color: #fff;
}
.file_actions button
{
  border: none;
  background: none;
}
.file_actions .dropdown-toggle
{
  border: none;
  background: none;
  padding: 0;
}
.table-responsive{overflow-x: hidden}
.file_buttons li button{
  color: #cdcdcd;
  /*margin-left: 5px;*/
  padding: 5px 10px;
  background: transparent;
}
.hamburger-toppings i{font-size: 20px !important}
.actions_list{/*display: inline-flex; */list-style: none; padding: 0}
.actions_list li{width: 100%}
.actions_list button{font-size: 14px}
.text-secondary{font-size: 15px;}
.circle_share{
  border: 2px solid #cdcdcd;
  width: 15%;
  /* margin: 0 auto; */
  border-radius: 50%;
  padding: 10px;
}
.circle_share:hover{background-color: #f0f0f0}
button.dropdown-toggle{/*padding: 3px 10px*/}
.ellipsis_label{float: left; line-height: 2.5em}
.action_buttons{float: right; position: static}
#drawer_right li span {background-color: white;}
#drawer_right li span.active { border:1px solid #dee2e6 ; border-bottom: 2px solid #5cb85c; }
#drawer_right li span:hover { background-color: rgb(243, 242, 241);}
.table > thead > tr > th{text-transform: none}
.drawer_right_tabs li span{text-transform: capitalize; font-size: 15px;padding: 5px 10px;padding-top: 8px}
.drawer_right_tabs li span > i{color: #317ab9;
  font-size: 20px;
  margin: 5px 10px;}
#page-content .dropdown-menu{    top: -5px;
  left: 30px; min-width: 200px}
div.action_buttons > .dropdown-toggle{padding: 0px}
#page-content .dropdown-menu:before {
  border-right: 11px solid rgba(0, 0, 0, 0.2);
  border-top: 11px solid rgba(0, 0, 0, 0);
  border-bottom: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  left: -12px !important;
  right: auto !important;
  top: 5px;
}
#page-content .dropdown-menu:after {
  border-right: 11px solid #FFFFFF;
  border-top: 11px solid rgba(0, 0, 0, 0);
  border-bottom: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  left: -11px !important;
  right: auto !important;
  top: 5px;
}
.badge{position: absolute;right: 7px; border-radius: 50%; border: 1px solid #cdcdcd}
.badge[id*='badge_list_'] {
  position: relative;/*left: 30px; top:-40px; */border-radius: 50%; border: 1px solid #cdcdcd
}

.switch {
  position: relative;
  display: inline-block;
  width: 47px;
  height: 27px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: rgb(73, 130, 5);
}

input:focus + .slider {
  box-shadow: 0 0 1px #101010;
}

input:checked + .slider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
}

.slider.round {
  border-radius: 40px;
}

.slider.round:before {
  border-radius: 50%;
}
.table > tbody > tr.active{
  background-color: rgb(237,235,233);
}
/*.table > tbody > tr.active > td:last-child{
   border-right: 4px solid rgb(73, 130, 5);
  border-right-style: inset;
 }*/
.table > tbody > tr.active > td:last-child {
  position: relative;
}

.table > tbody > tr.active > td:last-child:before {
  content : "";
  position: absolute;
  right    : 0;
  z-index: 98;
  top  : 5px;
  width  : 5px;
  height   : 85%;  /* or 100px */
  background:rgb(73, 130, 5) ;
}
.table > tbody > tr.active > td{
  color: #0e0e0e;
  font-weight: bold;
}
#views_type .dropdown-toggle{
padding: 8px 5px;
}
.no_opacity{
  opacity: 0;
}
opacity{
  opacity: 1;
}
.no_active_row{
  color: #999;
}
/*.checkbox_label{
  display: none;
}*/
.mosaicBox:hover{
  background-color: #f0f0f0;
}
.checkbox__input:checked + .mosaicBox{
  color: red;
}
thead .checkbox_label {
  position: absolute !important;
  top: 13px !important;
  left: 10px !important;
}
/*********************************/
.front_folder {
  display: block;
  position: absolute;
  left: -3px;
  right: -3px;
  bottom: -4px;
}
.back_folder {
  display: block;
  position: absolute;
  left: -3px;
  right: -3px;
  bottom: -4px;
}
.dg-content-body{border-bottom: none; text-align: center; margin-top: 20px}
.dg-btn--cancel {
  color: #0096D9;
  background-color: #fefefe;
  border-color: #0096D9;
}
/*
input:checked{
  height: 50px;
  width: 50px;
}*/
</style>

<style>
/*#dropzone .dz-preview {
  display: flex;
}
#dropzone .dz-preview .dz-image {
  padding: 10px;
  width: 25% !important;
}

#dropzone .dz-preview .dz-details {
  padding: 10px 0;
}
#dropzone .dz-error-message{
  display: none;
}*/
/*#dropzone .dz-remove:before {
  content: "\f013";
  font-family: "Font Awesome 5 Free";
  font-style: normal;
  font-variant-caps: normal;
  font-variant-ligatures: normal;
  font-weight: 900;
  height: 16px;
  line-height: 16px;
  text-rendering: auto;
  width: 16px;
  -webkit-font-smoothing: antialiased;
}*/
#dropzone {
  letter-spacing: 0.2px;
  color: #777;
  transition: background-color .2s linear;
  height: 200px;
  padding: 5px;
}

#dropzone .dz-preview {
  width: 100%;
  min-height: 50px;
  display: inline-block;
  border-bottom:1px solid #cdcdcd;
  padding: 2px 5px;
  margin: 0;
  box-shadow: 0 4px 2px -2px gray;
  background-color: white;
}
#dropzone .dz-preview .dz-image {
  width: 50px;
  height: 50px;
  margin: 0 10px;
  float: left;
}
#dropzone .dz-preview .dz-image > div {
  width: inherit;
  height: inherit;
  border-radius: 50%;
  background-size: contain;
}
#dropzone .dz-preview .dz-image > img {
  width: 100%;
}

#dropzone .dz-preview .dz-details {
  transition: opacity .2s linear;
  text-align: left;
  float: left;
  padding: 0 !important;
  opacity: 1;
  min-width: auto;
  position: relative;
  line-height: inherit;
  background-color: transparent;
  color: #999;
}
#dropzone .dz-success-mark, .dz-error-mark{
  /*display: none;*/
  position: absolute;
  top: 4px !important;
  right: 0;
  padding: 0px;
  width: 20% !important;
  margin-right: 20px;
}
#dropzone .dz-error-message{
 float: right;
  font-size: x-small;
  top: 50px !important;
}
/*#dropzone .dz-remove {
  content: '';
  display: block;
  text-decoration:none;
  background-image: url("https://www.pngfind.com/pngs/m/47-471196_icon-trash-png-font-awesome-trash-o-transparent.png");
  background-repeat: no-repeat;
}*/
#dropzone .dz-filename {
  width:215px;
  margin:0 auto;
  /*border:solid 1px #d4d4d4;
  padding:10px;*/
  overflow:hidden;
  text-overflow:ellipsis;
  overflow:hidden;
  white-space:nowrap;
}
.dropzone .dz-preview .dz-details .dz-size {
  margin-bottom: 0;
}

#dropzone .dz-preview .dz-remove:before {
  content: "\f1f8";
  font-family: "FontAwesome";
  font-size: 20px;
}
#dropzone .dz-preview .dz-remove:hover {
  text-decoration: none;
}
.dropzone .dz-preview .dz-remove{
  opacity: 1 !important;
  color: #999 !important;
  position: relative !important;
  border: none !important;
  bottom: 0 !important;
  font-size: 0 !important;
  padding: 0 !important;
  letter-spacing:normal !important;
}
.dropzone .dz-preview .dz-remove:after{
  content: " ";
}
.dropzone .dz-preview .dz-success-mark svg, .dropzone .dz-preview .dz-error-mark svg {
  display: block;
  width: 20px;
  height: 25px;
}
.dropzone .dz-preview .dz-success-mark svg path {
  fill: #5cb85c;
}
.dropzone .dz-preview .dz-error-mark svg  path {
  fill: #dc3545;
}
.dropzone .dz-preview .dz-progress
{
  left: 60% !important;
  top: 20% !important;
  border-radius: 4px;
}

.dropzone .dz-preview .dz-progress {
  background: linear-gradient(-45deg, #ccc, #73a373, #30af30, #5cb85c);
}
.dropzone .dz-preview .dz-progress .dz-upload {
  background: #5cb85c;
}

/* smartphones, touch screens */
@media (hover: none) {
  /*body {
    background-color: lightblue;
  }*/
}

@media (max-height: 880px) {
  /*body {
    background-color: #5cb85c;
  }*/
}
@media (max-width: 40em) {
  #actions_menu{
    width: 100%;
  }
  #actions_menu > div{flex-wrap: wrap}
#searchForm{width: 100%}
  #searchForm input{width: 100%}
  .header-explorer > div.float-right:first-child{width: 100%;}
  #actions_menu > div > div:nth-child(1) > li:nth-child(2) > li > button{background: transparent; color: #5d5d5d}
}

/*****marquee**********/
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: Arial, Helvetica, sans-serif;
}
.breadcrumbs li {
  display: inline-block;
}
.breadcrumbs li:after {
 /* content: " >";*/
  color: rgb(211, 211, 211);
}
.breadcrumbs li:last-child:after,.breadcrumbs li:nth-last-child(2):after {
 /* content: "";*/
}
button {
  padding: 1px 3px;
  border: none;
  border-radius: 0px;
}
#breadcrumbs li:not(:first-child):not(:last-child):not(#button){
  /*display: none;*/
}
#breadcrumbs {padding-left: 0; margin-bottom: 0}
.breadcrumbs li:hover:not(.text-purple){background: #ddd}
.breadcrumbs li:hover:not(.text-purple)::before{background: #f8f9fa;}
.breadcrumbs li::before{padding-left: 5px}
.breadcrumbs li:last-child{padding-right: 15px;padding-left: 15px}
#table_show{list-style: none; padding: 0}
#table_show button span{  color: #333333;
  font-weight: 300;font-size:30px!important}
#table_show button.dropdown-toggle{
  padding: 0;
}
.table > thead > tr > th:nth-child(2){
  width: 50px;
  text-align: center !important;
}

#clientsDocs > tbody > tr> td:nth-child(1){
  width: 5%;
  padding: 0;
  padding-left: 10px;
}

#clientsDocs > tbody > tr > td:nth-child(2){
  padding: 0;
}
#clientsDocs > tbody > tr > td:nth-child(3){
  width: 30%;
}
#clientsDocs > tbody > tr > td:nth-child(5){
  width: 12%;
}
#clientsDocs > tbody > tr > td:nth-child(6){
  width: 15%;
}


.users_folder_list{
  background: #fff;
  border-radius:5px;
  box-shadow: 0 2px 3px 0 rgba(0,0,0,.1);
}

.users_folder_list td{
  border-bottom:1px solid #f6f6f6;
  padding:5px 10px;
}

.users_folder_list td:nth-child(2){
  text-align: right;
  width: 40px;
}

/*.users_folder_list tr:last-child td{
  border:none;
  padding:30px 10px 10px;
  text-align: center;
}*/

.users_folder_list input[type=checkbox] {
  cursor: pointer;
  height: 30px;
  margin:4px 0 0;
  position: absolute;
  opacity: 0;
  width: 30px;
  z-index: 2;
}

.users_folder_list input[type=checkbox] + span {
  background: #e74c3c;
  border-radius: 50%;
  box-shadow: 0 2px 3px 0 rgba(0,0,0,.1);
  display: inline-block;
  height: 24px;
  margin:4px 0 0;
  position:relative;
  width: 24px;
  transition: all .2s ease;
}

.users_folder_list input[type=checkbox] + span::before,.users_folder_list input[type=checkbox] + span::after{
  background:#fff;
  content:'';
  display:block;
  position:absolute;
  width:4px;
  transition: all .2s ease;
}

.users_folder_list input[type=checkbox] + span::before{
  height:12px;
  left:10px;
  top:7px;
  -webkit-transform:rotate(-45deg);
  transform:rotate(-45deg);
}

.users_folder_list input[type=checkbox] + span::after{
  height:12px;
  right:10px;
  top:7px;
  -webkit-transform:rotate(45deg);
  transform:rotate(45deg);
}

.users_folder_list input[type=checkbox]:checked + span {
  background:#2ecc71;
}

.users_folder_list input[type=checkbox]:checked + span::before{
  height: 9px;
  left: 7px;
  top: 10px;
  -webkit-transform:rotate(-47deg);
  transform:rotate(-47deg);
}

.users_folder_list input[type=checkbox]:checked + span::after{
  height: 14px;
  right: 8px;
  top: 6px;
}

.users_folder_list input[type=submit] {
  background-color: #2ecc71;
  border: 0;
  border-radius: 4px;
  color: #FFF;
  cursor: pointer;
  display: inline-block;
  font-size:16px;
  text-align: center;
  padding: 12px 20px 14px;
}
.users_folder_list tr label{
  font-size: 10px;
  width: auto;
}
.users_folder_list tr{
  width: 50%;
  float: left;
}
.users_folder_list tr > td > label > div{
  float: right;
}
.italic_{font-size: 10px; font-style: italic}
input[type="checkbox"]:checked+label{ font-weight: bold; }

.check_noti input[type="checkbox"]:before {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  content: "\f096";
  opacity: 1 !important;
  margin-top: -25px;
  appearance: none;
  background: #fff;
}

.check_noti input[type="checkbox"]:checked:before {
  content: "\f046";
}

.check_noti input[type="checkbox"] {
  font-size: 22px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>
